(function () {
    'use strict';

    angular
        .module('app', [
            'ui.router', // @uirouter/angularjs, formerly angular-ui-router
            'ui.select', // ui-select
            'app.accountManagement',
            'mm.foundation', // angular-foundation-6, foundation-sites
            'templates',
            'ngCookies', // angular-cookies
            'ngSanitize', // angular-sanitize
            'ngIdle', // ng-idle
            'app.learnAboutThisPage'
        ]);

    angular
        .module('app')
        .run(['$rootScope',
            function ($rootScope) {
                $rootScope.$on('$viewContentLoaded', function () {
                    $(document).foundation();
                });
            }
        ])
        // Used for ui-select, from: http://angular-ui.github.io/ui-select/demo-basic.html
        .filter('propsFilter', function () {
            return function (items, props) {
                var out = [];

                if (angular.isArray(items)) {
                    var keys = Object.keys(props);

                    items.forEach(function (item) {
                        var itemMatches = false;

                        for (var i = 0; i < keys.length; i++) {
                            var prop = keys[i];
                            var text = props[prop].toLowerCase();
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }

                        if (itemMatches) {
                            out.push(item);
                        }
                    });
                } else {
                    // Let the output be the input untouched
                    out = items;
                }

                return out;
            };
        })
        .config(['uiSelectConfig', function (uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])

        .config(['IdleProvider', 'TitleProvider', function (IdleProvider, TitleProvider) {
            IdleProvider.autoResume('notIdle');
            TitleProvider.enabled(false);
        }])

        // Configure Idle service (https://github.com/HackedByChinese/ng-idle) and begin watching for idleness if user is already authenticated.
        //Moved to accountManagement due to authentication
        .run(['Idle', 'Keepalive', 'authentication', 'config', function (Idle, Keepalive, authentication, config) {

            Idle.watch();
       }])
        .config(['uiSelectConfig', function (uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.html5Mode(true);
        }]);

    angular
        .module('app.auth', [
            'angularMoment', // angular-moment
            'mm.foundation' // angular-foundation-6
        ]);

    angular
        .module('templates', []);
})();
/**
 * Created by tlester3 on 4/16/16.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(config);

    config.$inject = ['$urlRouterProvider'];

    function config($urlRouterProvider) {
        $urlRouterProvider
            .otherwise('/');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('config', config);

    config.$inject = ['$http'];

    function config($http) {
        var $config;

        return { get: get };

        function get() {
            if (!$config) {
                $config = $http.get('/config.json').then(function (response) {
                    if (typeof response.data !== 'object') {
                        response.status = 404;
                        response.statusText = 'Not Found';
                        throw response;
                    }
                    return response.data;
                });
            }
            return $config;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .factory('_', lodash);

    lodash.$inject = ['$window'];

    function lodash($window) {
        return $window._;
    }
})();
/**
 * Created by tlester3 on 4/17/16.
 */
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('authentication', authentication);

    authentication.$inject = ['$http', '$cookies', '$q', '$log', '$window', '$location', 'config', '_', 'moment'];

    function authentication($http, $cookies, $q, $log, $window, $location, config, _, moment) {
        var host = $window.location.protocol + "//" + $window.location.host;

        return {
            isLoggedIn: isLoggedIn,

            register: register,
            logIn: logIn,
            getLastLoginDate: getLastLoginDate,
            logOut: logOut,
            logOutOfAppOnly: logOutOfAppOnly,
            logOutCasOnly: logOutCasOnly,
            keepAlive: keepAlive,
            isAosProfileValid: isAosProfileValid,
            isCommunityArchived: isCommunityArchived,
            getLoginStats: getLoginStats,

            getProxyTicket: getProxyTicket,

            getArmyComponents: getArmyComponents,
            getBranchOfServices: getBranchOfServices,
            getCivilianPayGrades: getCivilianPayGrades,
            getDispositions: getDispositions,
            getPayGrades: getPayGrades,

            setUserProfile: setUserProfile,
            getUserProfile: getUserProfile,
            getCommunities: getCommunities,

            changeLoginEmail: changeLoginEmail,
            changeLoginPassword: changeLoginPassword,

            getEmail: getEmail,
            getCacInfo: getCacInfo,
            getCasInfoForUser: getCasInfoForUser,
            getCasInfoForUsers: getCasInfoForUsers,
            getCacInfoFromCard: getCacInfoFromCard,
            resetUser: resetUser,
            resetPassword: resetPassword,
            enableUser: enableUser,
            disableUser: disableUser,
            refreshUser: refreshUser,
            setAdminStatusAFWP: setAdminStatusAFWP,
            setAdminStatus: setAdminStatus,
            verifyAccount: verifyAccount,
            sendVerificationEmail: sendVerificationEmail,

            getCommunitiesWithArchives: getCommunitiesWithArchives,
            addCommunityInTree: addCommunityInTree,
            changeCommunityInTree: changeCommunityInTree,
            inactivateCommunity: inactivateCommunity,

            checkCoreApiHealth: checkCoreApiHealth,
            checkSsoHealth: checkSsoHealth
        };

        function saveEmail(email, expiration) {
            $cookies.put('cas-email', email, {
                expires: expiration
            });
        }

        function saveToken(token, expiration) {
            $cookies.put('cas-ticket', token, {
                expires: expiration
            });
        }

        function saveCacInfo(registered, inUse, expiration) {
            $cookies.put('cac-registered', registered, {
                expires: expiration
            });
            $cookies.put('cac-in-use', inUse, {
                expires: expiration
            });
        }

        function getToken() {
            return $cookies.get('cas-ticket');
        }

        function getEmail() {
            return $cookies.get('cas-email');
        }

        function getCacInfo() {
            return {
                registered: $cookies.get('cac-registered'),
                inUse: $cookies.get('cac-in-use')
            };
        }

        function destroyTokens() {
            $cookies.remove('cas-ticket');
            $cookies.remove('cas-email');
            $cookies.remove('cac-registered');
            $cookies.remove('cac-in-use');
        }

        function isLoggedIn() {
            return !!getToken();
        }

        function register(params) {
            var data = {
                email: params.email,
                password: params.password
            };
            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/login/sign_up', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        // NOTE: CHANGED FOR CORE
        function logIn(ticket, service) {
            if (service === null || service === undefined) {
                service = encodeURIComponent(host + ($location.path() === '/' ? '' : $location.path()));
            }

            var data = {
                ticket: ticket,
                service: service
            };

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/login/sign_in_with_ticket', data);
            }).then(httpSuccess).then(onSuccess).catch(httpFailure);

            function onSuccess(response) {
                var expiration = moment().add(response.expires_in, 'minutes').toDate();
                saveToken(response.access_token, expiration);
                saveEmail(response.email, expiration);
                saveCacInfo(response.cac_registered, response.cac_in_use, expiration);

                return getCasInfoForUser(response.email)
                    .then(function (result) {
                        response.isAdmin = result.user.admin;
                        return response;
                    })
                    .catch(function (error) {
                        return httpFailure(error);
                    });
            }
        }

        function getCacInfoFromCard() {
            return config.get().then(function (configData) {
                console.log("🔍 CAC Info config:", configData.cacInfo);

                if (!configData.cacInfo || !configData.cacInfo.enable) {
                    console.log("⚠️ CAC Info disabled or missing in config");
                    return null;
                }

                console.log("📡 Calling CAC Info endpoint:", configData.cacInfo.path);

                return $http.get(configData.cacInfo.path, {timeout: 100000,
                    withCredentials: true})
                    .then(httpSuccess)
                    .catch((err) => {
                        console.error("❌ CAC Info request failed:", err);
                        if (err && err.data) {
                            console.error("🔎 Error response data:", err.data);
                        }
                        if (err && err.status) {
                            console.error("📛 HTTP status:", err.status);
                        }
                        return null;
                    });

            });
        }



        function getCasInfoForUsers(searchString) {
            var data = {
                searchString: searchString
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/lookup_users_cas", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCasInfoForUser(email) {
            var data = {
                email: email
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/user_info_cas", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getLoginStats(startDate,endDate) {
            var data = {
                startDate: startDate,
                endDate: endDate
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + "/authorized_api/users/login_stats", data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getLastLoginDate() {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/get_last_login', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOutOfAppOnly () {
            return config.get().then(function (configData) {
                var service = encodeURIComponent($window.location.protocol + "//" + $window.location.host);
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', {authorization: getToken(), service: service});
            }).then(httpSuccess).catch(httpFailure);
        }

        function logOut() {
            var casServer = "";
            return config.get().then(function (configData) {
                casServer = configData.casServer; // Store value while config data is in-scope
                return $http.post(configData.coreServer + '/authorized_api/users/sign_out', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                // Destroying tokens should come after logging out via Core API
                destroyTokens();
                // See loggedOut.routes.js
                window.location.href = casServer + 'logout?service=' +
                    encodeURI($window.location.protocol + "//" + $window.location.host + "/logged-out");
            }).catch(httpFailure).catch(function (error) {
                destroyTokens();
                return $q.reject(error);
            });
        }

        // Used for email and password changes where the API logs the user out of Core, it seems,
        // and the "log in first" error throws things off.
        function logOutCasOnly() {
            destroyTokens();
            return config.get().then(function (configData) {
                // See loggedOut.routes.js
                window.location.href = configData.casServer + 'logout?service=' +
                    encodeURI($window.location.protocol + "//" + $window.location.host + "/logged-out");
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function keepAlive() {
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/keep_alive', { authorization: getToken() });
            }).then(httpSuccess).then(function (response) {
                saveToken(getToken(), new Date(response.expiresOnDate));
                return response;
            }).catch(httpFailure).catch(function (error) {
                destroyTokens();
                return $q.reject(error);
            });
        }

        function getProxyTicket() {
            var data = {};
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/proxyTicket', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function verifyAccount (emailAddress, token) {
            var data = {
                email: emailAddress,
                token: token
            };
            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/login/verify_cas_account', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function sendVerificationEmail (emailAddress){
            var data = {
                email: emailAddress
            };
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/login/get_cas_verification_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function resetUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/reset_account', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function resetPassword(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/reset_with_temp_password', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function enableUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/enable', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function disableUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/disable', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function refreshUser(emailAddress, proxyTicket) {
            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/refresh', data);
            }).then(httpSuccess).catch(httpFailure);
        }


        function setAdminStatusAFWP(emailAddress, isRemovingAdmin) {
            var data = {
                userEmail: emailAddress,
                isRemovingAdmin: isRemovingAdmin
            };
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_admin_status_AFWP', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setAdminStatus(emailAddress, isRemovingAdmin, proxyTicket) {

            var data = {
                userEmail: emailAddress,
                proxyTicket: proxyTicket,
                isRemovingAdmin: isRemovingAdmin
            };

            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_admin_status', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function isAosProfileValid(aosProfile) {
            if (!isLoggedIn()) return false;

            var isProfileValid = aosProfile.firstName &&
                aosProfile.lastName &&
                aosProfile.dateOfBirth &&
                aosProfile.communityAffiliationId &&
                aosProfile.branchOfService &&
                aosProfile.armyComponent &&
                aosProfile.dispositions.length > 0;

            //check dispositions
            if (_.indexOf(aosProfile.dispositions, 'Service Member') >= 0) isProfileValid = isProfileValid && aosProfile.payGrade;
            if (_.indexOf(aosProfile.dispositions, 'Family Member') >= 0) isProfileValid = isProfileValid && aosProfile.sponsorPayGrade;
            if (_.indexOf(aosProfile.dispositions, 'DoD Civilian') >= 0) isProfileValid = isProfileValid && aosProfile.civilianPayGrade;

            return !!isProfileValid;

        }

        function isCommunityArchived(communityAffiliationId) {
            return getCommunityInfo(communityAffiliationId)
                .then(function (comm) {
                    return comm.communityAffiliations.isArchived;
                });
        }

        function getArmyComponents() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/armyComponents");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getBranchOfServices() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/branchOfService");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCivilianPayGrades() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/civilianPayGrades");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getDispositions() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/dispositions");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getPayGrades() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + "/public_api/uidata/payGrades");
            }).then(httpSuccess).catch(httpFailure);
        }

        function getUserProfile(email) {
            var data = {
                authorization: getToken()
            };

            if(angular.isDefined(email) && email !== null){
                data.email = email;
            }

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/get_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function setUserProfile(profile) {
            var profileCopy = angular.copy(profile, {});
            var data = {
                authorization: getToken(),
                aosUser: profileCopy
            };
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/set_user_profile', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunities(params) {
            var data = angular.copy(params);
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/uidata/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunityInfo(communityAffiliationId) {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/public_api/uidata/communities/' + communityAffiliationId);
            }).then(httpSuccess).catch(httpFailure);
        }

        function changeLoginEmail(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/change_login_email', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function changeLoginPassword(params) {
            var data = angular.copy(params, {});
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/users/change_login_password', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function getCommunitiesWithArchives() {
            var data = {withArchives: 1};
            data.authorization = getToken();
            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/ui_data/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function addCommunityInTree(params) {
            var data = {
                isArchived: params.isArchived,
                name: params.name,
                isLeaf: params.isLeaf,
                communityParentId: params.communityParentId
            };

            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.put(configData.coreServer + '/authorized_api/ui_data/communities', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        function inactivateCommunity(params) {
            var data = {
                communityAffiliationId: params.communityAffiliationId
            };
            data.authorization = getToken();

            // TODO: Move this VMIS-specific functionality elsewhere
            /*
            return config.get().then(function (configData) {
                return $http.post(configData.apiServer + '/authorized_api/inactivate_orgs_in_community', data);
            }).then(httpSuccess).catch(httpFailure);
            */
        }

        function changeCommunityInTree(params) {
            var data = {
                communityAffiliationId: params.id,
                isArchived: params.isArchived,
                name: params.name,
                isLeaf: params.isLeaf,
                communityParentId: params.communityParentId
            };
            data.authorization = getToken();

            return config.get().then(function (configData) {
                return $http.post(configData.coreServer + '/authorized_api/ui_data/communities/change', data);
            }).then(httpSuccess).catch(httpFailure);
        }

        /**
         * Gets information from Core API health check.
         * @param params Any of acceptable parameters to check aspects of API health (unacceptable ones are ignored) (optional)
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkCoreApiHealth(params) {
            return config.get().then(function (configData) {
                return checkHealth(configData.coreServer, params);
            });
        }

        function checkHealth(api, params) {
            if (params !== undefined && !Array.isArray(params)) {
                console.warn("Attempted to pass non-array into API health check!");
                return;
            }
            var paramsStr = "";

            // "params" is optional
            if (params) {
                paramsStr += "?test=";
                params.forEach(function (param) {
                    paramsStr += param.toString() + ",";
                });
            }

            return $http.get(api + '/check_health' + paramsStr).then(httpSuccess).catch(httpFailure);
        }

        /**
         * Gets version information from SSO (CAS) endpoint.
         * @returns {*} Returns a promise of the data from the API.
         */
        function checkSsoHealth() {
            return config.get().then(function (configData) {
                return $http.get(configData.coreServer + '/login/getCASVersion').then(httpSuccess).catch(httpFailure);
            });
        }

        function httpSuccess(response) {
            if (response.status === 200) {
                if (response.data.success === true) {
                    return response.data;
                }
            }
            return $q.reject(response);
        }

        function httpFailure(error) {
            if (error.status === 200) {
                $log.error(error.config.method, error.config.url, error.data.error);
                return $q.reject(error.data.error);
            }
            var errorText = 'Error: ' + error.status + ', ' + error.statusText;
            $log.error(error.config.method, error.config.url, errorText);
            return $q.reject(errorText);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('redirect', redirect);

    redirect.$inject = ['$window', '$location'];

    function redirect($window) {
        return {
            returnTo: returnTo
        };

        function returnTo(returnTo) {
            var url = $window.decodeURIComponent(returnTo);
            if (url.indexOf('?') == -1) {
                url = url.concat('?');
            } else {
                url = url.concat('&');
            }
            url = url.concat('logged-in');
            $window.location.href = url;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('convertToNumber', ConvertToNumber);

    ConvertToNumber.$inject = [];

    function ConvertToNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    if (angular.isNumber(val) && isFinite(val)) {
                        return val.toString();
                    }
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('confirmDataError', ConfirmDataError);

    ConfirmDataError.$inject = [];

    function ConfirmDataError() {
        return {
            require: 'ngModel',
            link: link
        };

        function link(scope, elm, attrs, ctrl) {
            scope.$watch(attrs.confirmDataError, function (error) {
                elm[0].setCustomValidity(error);
                ctrl.$setValidity('confirmDataError', error ? false : true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('modal', modal);

    modal.$inject = [];

    function modal() {
        return {
            restrict: 'E',
            transclude: {
                body: '?modalBody',
                footer: '?modalFooter'
            },
            templateUrl: 'app/common/directives/modal/modal.template.html',
            controller: function() {},
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                close: '<?',
                modalTitle: '@?'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('loadingIcon', LoadingIcon);

    LoadingIcon.$inject = [];

    function LoadingIcon() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/loadingIcon/loadingIcon.template.html',
            controller: function () {},
            controllerAs: 'loadingIcon',
            scope: {
                show: '=',
                // TODO: Make size parameter so these two cannot conflict if both used
                little: '=?',
                littlest: '=?',
                pushDown: '=?'
            },
            bindToController: true
        };
    }
})();

/*
 http://foundation-datepicker.peterbeno.com/example.html
 */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('vmisDatepicker', VmisDatepicker);

    VmisDatepicker.$inject = ['$timeout'];

    function VmisDatepicker($timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                format: '@?',
                startDate: '<?',
                endDate: '<?',
                leftArrow: '@?',
                rightArrow: '@?'
            },
            link: link
        };

        function link(scope, element, attributes, controller) {
            var target = attributes.target ? '#' + attributes.target : element;
            var format = scope.format || moment.ISO_8601;
            var datepicker;


            $timeout(function () {
                datepicker = $(target).fdatepicker({
                    initialDate: new Date(),
                    leftArrow: scope.leftArrow || defaultArrow('left'),
                    rightArrow: scope.rightArrow || defaultArrow('right'),
                    onRender: onRender
                }).on('changeDate', onChangeDate).on('show', onShow).data('datepicker');
            }, 100);

            controller.$validators.dateValidator = function (modelValue, viewValue) {
                if (modelValue) {
                    var startDate = dateExist('startDate');
                    if (startDate && moment(modelValue).isBefore(startDate, 'day')) return false;
                    var endDate = dateExist('endDate');
                    if (endDate && moment(modelValue).isAfter(endDate, 'day')) return false;
                }
                return viewValue ? moment(viewValue, format, true).isValid() : true;
            };

            controller.$formatters.unshift(function (modelValue) {
                if (!format || !modelValue) return "";
                var retVal = moment(new Date(modelValue));
                return scope.format ? retVal.format(scope.format) : retVal;
            });

            controller.$parsers.unshift(function (viewValue) {
                var date = moment(viewValue, format);
                return (date && date.isValid() && date.year() > 1900 ) ? date.toDate() : "";
            });

            scope.$on('$destroy', function () {
                datepicker.remove();
            });

            function defaultArrow(direction) {
                return '<icon>' +
                    '<svg class="icon icon-fa-chevron-' + direction + '">' +
                    '<use xlink:href="#icon-fa-chevron-' + direction + '"></use>' +
                    '</svg>' +
                    '</icon>';
            }

            function onRender(utcDate) {
                var localDate = moment(utcDate).add(utcDate.getTimezoneOffset(), 'minutes');
                var startDate = dateExist('startDate');
                var endDate = dateExist('endDate');
                var renderStart = startDate ? moment(localDate).isSameOrAfter(startDate, 'day') : true;
                var renderEnd = endDate ? moment(localDate).isSameOrBefore(endDate, 'day') : true;
                return renderStart && renderEnd ? '' : 'disabled';
            }

            function onChangeDate(event) {
                var date = moment(event.date).add(event.date.getTimezoneOffset(), 'minutes').startOf('day').toDate();
                scope.$apply(function () {
                    controller.$setViewValue(date, 'programmatic');
                    controller.$modelValue = date;
                });
            }

            function onShow() {
                if (!controller.$modelValue) return;
                var date = moment(controller.$modelValue).startOf('day').toDate();
                datepicker.update(date);
            }

            function dateExist(date) {
                if (angular.isDefined(attributes[date])) {
                    if (scope[date] === undefined) return attributes[date] ? false : new Date();
                    if (scope[date] === null) return false;
                    return scope[date];
                }
                return false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('emailValidator', emailValidator);

    function emailValidator(){
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                formError: '=emailValidatorError',
                emailValidated: '=emailValidatorValidated',
                emailValidatedCallback: '=emailValidatedCallback'
            },
            link: function ($scope, elm, attrs, ctrl){

                // only apply the validator if ngModel is present and Angular has added the email validator
                if (ctrl && ctrl.$validators.email) {
                    // trigger on key up event
                    elm.on('keyup', validateOnKeyup);
                }

                function validateOnKeyup(){
                    //cancel the last timeout
                    clearTimeout($scope.timeOut);
                    $scope.emailValidated = false;
                    ctrl.$setValidity("emailValidated", false);

                    // get email value
                    var email = ctrl.$viewValue;

                    // wait for user to stop typing before processing validity
                    $scope.timeOut = setTimeout(function(){
                        // force apply to update error message consistently
                        $scope.$apply(function(){
                            // check if email field has been deleted completely
                            if(email === "" || !email) {
                                $scope.formError = "Email address is required";
                                return;
                            }

                                $scope.emailValidatedCallback().then(function(error){
                                    if (error){
                                        $scope.formError = error;
                                        $scope.emailValidated = false;
                                        ctrl.$setValidity("emailValidated", false);
                                    } else {
                                        $scope.formError = "";
                                        $scope.emailValidated = true;
                                        ctrl.$setValidity("emailValidated", true);
                                    }
                                });
                        });
                    }, 500);
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('passwordValidator', PasswordValidator);

    PasswordValidator.$inject = ['config'];

    // Provide validators for each aspect of a password:
    // Min 15 characters
    // 2 uppercase letters
    // 2 lowercase letters
    // 2 numbers
    // 2 special characters
    // 0 spaces

    // Example: https://docs.angularjs.org/guide/forms - "Custom Validation"
    function PasswordValidator(config) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                return config.get().then(function (configData) {
                    var lengthRegex = RegExp(configData.passwordRequirements.requirementChecks.lengthRegex);
                    var upperRegex = RegExp(configData.passwordRequirements.requirementChecks.upperRegex);
                    var lowerRegex = RegExp(configData.passwordRequirements.requirementChecks.lowerRegex);
                    var numRegex = RegExp(configData.passwordRequirements.requirementChecks.numRegex);
                    var specialRegex = RegExp(configData.passwordRequirements.requirementChecks.specialRegex);
                    var spaceRegex = RegExp(configData.passwordRequirements.requirementChecks.spaceRegex);

                    ctrl.$validators.passwordLength = function(modelValue, viewValue) {
                        return lengthRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordUpper = function(modelValue, viewValue) {
                        return upperRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordLower = function(modelValue, viewValue) {
                        return lowerRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordNum = function(modelValue, viewValue) {
                        return numRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordSpecial = function(modelValue, viewValue) {
                        return specialRegex.test(modelValue);
                    };
                    ctrl.$validators.passwordSpace = function(modelValue, viewValue) {
                        // When empty, it technically doesn't have spaces but we want to
                        // keep the UI element red.
                        if (ctrl.$isEmpty(modelValue)) return false;

                        return spaceRegex.test(modelValue);
                    };
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('menuDropdown', menuDropdown);

    menuDropdown.$inject = [];

    function menuDropdown() {
        return {
            restrict: 'E',
            transclude: {
                'toggle': 'menuDropdownToggle',
                'pane': 'menuDropdownPane'
            },
            templateUrl: 'app/common/directives/dropdown/dropdown.view.html',
            controller: 'DropdownController',
            controllerAs: 'vm',
            scope: {
                active: '=?isOpen'
            },
            bindToController: true
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('DropdownController', DropdownController);

    DropdownController.$inject = ['$element', '$scope', '$transclude'];

    function DropdownController($element, $scope, $transclude) {
        var vm = this;
        var body = angular.element(document.querySelector('body'));

        vm.$onDestroy = onDestroy;
        vm.toggle = toggle;

        $transclude(function (clone) {
            var el = angular.element($element[0].querySelector('menu-dropdown>span'));
            el.append(clone);
        }, $element.parent(), 'toggle');

        $transclude(function (clone, scope) {
            scope.$close = close;
            var el = angular.element($element[0].querySelector('menu-dropdown>div'));
            el.append(clone);
        }, $element.parent(), 'pane');

        function onDestroy() {
            body.off('click', onClick);
        }

        function onClick(event) {
            var elementContents = Array.prototype.slice.apply($element[0].querySelectorAll('*'));

            if (elementContents.length <= 0) {
                return;
            }

            var isOuterElement = elementContents.every(function (node) {
                return node !== event.target;
            });

            if (isOuterElement || !vm.active) {
                close();
                $scope.$apply();
            }
        }

        function close() {
            vm.active = false;
            body.off('click', onClick);
        }

        function open() {
            vm.active = true;
            body.on('click', onClick);
        }

        function toggle() {
            if (vm.active) {
                close();
            } else {
                open();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('icon', Icon);

    Icon.$inject = [];

    function Icon() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/icon/icon.template.html',
            controller: function () {},
            controllerAs: 'icon',
            bindToController: true,
            scope: {
                name: '@',
                spin: '=?'
            }
        };
    }
})();
/**
 * Created by scuzzort3 on 8/11/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .directive('communitiesDropDown', communitiesDropDown);

    communitiesDropDown.$inject = [];

    function communitiesDropDown() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/communitiesDropDown/communitiesDropDown.view.html',
            controller: 'CommunitiesDropDownController',
            controllerAs: 'vm',
            scope: {
                onCommunityClick: '&',
                refreshFlag: '=',
                searchText: '=',
                disabledCommunityId: '=',
                startCollapsed: '=',
                showLeafs: '@',
                showInactive: '@'
            }
        };
    }
})();
/**
 * Created by scuzzort3 on 8/11/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('CommunitiesDropDownController', CommunitiesDropDownController);

    CommunitiesDropDownController.$inject = ['$element', '$scope', 'authentication'];

    function CommunitiesDropDownController($element, $scope, authentication) {
        var vm = this;
        vm.searchText = "";
        $scope.onCommunityClick = $scope.onCommunityClick();
        vm.showArchivedNodes = $scope.showInactive;
        vm.showLeafNodes = $scope.showLeafs;
        vm.disabledCommunityId = $scope.disabledCommunityId;
        vm.firstRender = $scope.startCollapsed;

        if(vm.showArchivedNodes === "true"){
            vm.showArchivedNodes = true;
        }
        else{
            vm.showArchivedNodes = false;
        }

        if(vm.showLeafNodes === "false"){
            vm.showLeafNodes = false;
        }
        else{
            vm.showLeafNodes = true;
        }

        $scope.$watch("refreshFlag",function(newValue,oldValue) {
            if(newValue === true) {
                $scope.refreshFlag = false;
                getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
            }
        });

        $scope.$watch("searchText",function(newValue,oldValue) {
            if(newValue !== undefined){
                vm.searchText = newValue;
                getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
            }
        });

        vm.changeBackgroundColor = changeBackgroundColor;
        vm.onClickExpandCollapse = onClickExpandCollapse;
        vm.onClickCommunityNode = onClickCommunityNode;
        vm.getIconNameForNode = getIconNameForNode;
        vm.isSelectedNode = isSelectedNode;
        vm.searchText = "";
        vm.communities = [];
        vm.isLoading = true;
        vm.nodeDataHasChanged = false;

        vm.isCommunitySelected = false;
        vm.selectedCommunity = null;

        vm.selectedCommunityName = "";
        vm.selectedCommunityIsLeaf = false;
        vm.selectedCommunityIsArchived = false;
        vm.selectedCommunityParentName = "";

        vm.search = function (searchText) {
            getCommunityDataWithFilter(vm.searchText, $scope.startCollapsed);
        };

        function changeBackgroundColor(element) {
            element.css('background-color', "gray");
        }

        function onClickExpandCollapse(communityNode) {
            if (communityNode.children !== null || communityNode.children.length > 0) {
                if (communityNode.hideChildren === true) {
                    communityNode.hideChildren = false;
                }
                else {
                    communityNode.hideChildren = true;
                }
            }
        }

        function onClickCommunityNode(communityNode) {
            $scope.onCommunityClick(communityNode);
        }

        function getIconNameForNode(communityNode) {
            // if we have no children, use a dot
            if (communityNode.isLeaf === 1) {
                return "fa-circle";
            }
            else if (communityNode.hideChildren === true) {
                return "fa-plus";
            }
            else {
                return "fa-minus";
            }
        }

        function getCommunityDataWithFilter(filter, collapseAll) {
            vm.communities = [];
            vm.isLoading = true;
            vm.nodeDataHasChanged = false;
            vm.isCommunitySelected = false;
            vm.selectedCommunity = null;

            authentication.getCommunitiesWithArchives()
                .then(function (result) {
                    vm.communities = [makeTreeViewFromCommunities(result, filter)];
                    vm.firstRender = collapseAll;
                });
        }

        function makeTreeViewFromCommunities(communitiesJson, filter) {
            var listEntry = {
                value: communitiesJson.value,
                id: communitiesJson.id,
                isArchived: communitiesJson.isArchived,
                isLeaf: communitiesJson.isLeaf,
                children: [],
                parent: null
            };

            listEntry.children = recursiveMakeCommunityHtml(communitiesJson.children, communitiesJson, vm.searchText).children;
            return listEntry;
        }

        function recursiveMakeCommunityHtml(childrenArray, parent, filter) {
            // NOTE: This function actually builds the tree, it also takes into account
            // filter text, and ensure that parents of nodes that should not be filtered
            // will still appear

            // create this level's list (NOTE: this list may or may not end up empty)
            var retList = [];

            // this flag determines if this level has any un-filtered information
            var hasUnfilteredChildren = 0;
            childrenArray.forEach(function (elem) {

                var listEntry = {
                    value: elem.value,
                    id: elem.id,
                    isArchived: elem.isArchived,
                    isLeaf: elem.isLeaf,
                    children: [],
                    hideChildren: vm.firstRender,
                    parent: parent
                };

                var shouldShowNode = true;

                if(elem.isArchived === 1){
                    shouldShowNode = vm.showArchivedNodes;
                }

                if(elem.isLeaf === 1){
                    shouldShowNode = vm.showLeafNodes;
                }

                if(shouldShowNode === true){
                    // this flag tells us if any of our children have unfiltered data in them
                    // this node should be shown in one of two instances
                    // 1) A child of this node matches the filter (see below)
                    // 2) This node itself matches the filter
                    var hasNestedChildren = 0;
                    if (elem.children !== null && elem.children.length !== 0) {
                        // get child info
                        var nestedChildrenInfo = recursiveMakeCommunityHtml(elem.children, elem, filter);
                        if (nestedChildrenInfo.hasUnfilteredChildren == 1) {
                            // if a child node of this node has unfiltered info, then make it collapsable
                            // set our nested children flag
                            hasNestedChildren = 1;
                            listEntry.children = nestedChildrenInfo.children;
                        }
                    }

                    // This if statement check for 3 things
                    // 1) If condition #2 is true -> this node matches the filter
                    // 2) If the filter is blank
                    // 3) If this node should be included because a child node matches the filter
                    // if any one of these statements are true, then the entry should be added to the list
                    // and we should set the hasUnfilteredChildren flag so parent calls will know to include
                    // this node in the tree
                    if (filter === "" || elem.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || hasNestedChildren == 1) {
                        hasUnfilteredChildren = 1;
                        retList.push(listEntry);
                    }
                }
            });

            return {
                hasUnfilteredChildren: hasUnfilteredChildren,
                children: retList
            };
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }

        function onSubmit() {
            $modalInstance.close(vm.communitySelected);
        }

        function isSelectedNode(communityNode) {
            if (vm.selectedCommunity !== null) {
                if (communityNode.id == vm.selectedCommunity.id) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage', [
        ]);
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .directive('learnAboutThisPage', learnAboutThisPage);

    learnAboutThisPage.$inject = [];

    function learnAboutThisPage() {
        return {
            restrict: 'E',
            templateUrl: 'app/common/directives/learnAboutThisPage/learnAboutThisPage.view.html',
            controller: 'LearnAboutThisPageController',
            controllerAs: 'vmWidget',
            scope: {
                learnTitle: '@',
                textBody: '@'
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .controller('LearnAboutThisPageController', LearnAboutThisPageController);

    LearnAboutThisPageController.$inject = ['$scope', '$modal'];

    function LearnAboutThisPageController($scope, $modal) {
        var vmWidget = this;

        vmWidget.learnTitle = $scope.learnTitle;
        vmWidget.textBody = $scope.textBody;

        vmWidget.openModal = openModal;

        function openModal() {
            var modalInstance = $modal.open({
                templateUrl: 'app/common/directives/learnAboutThisPage/learnAboutModal.template.html',
                controller: 'LearnAboutModalController',
                controllerAs: 'vmWidgetModal',
                backdrop: 'static',
                keyboard: false
            });
            modalInstance.learnTitle = vmWidget.learnTitle;
            modalInstance.textBody = vmWidget.textBody;
            // modalInstance.result
            // To Do: add error catching

        }
    }
})();
/**
 * Created by scuzzort3 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('app.learnAboutThisPage')
        .controller('LearnAboutModalController', LearnAboutModalController);

    LearnAboutModalController.$inject = ['$modalInstance'];

    function LearnAboutModalController($modalInstance) {
        var vmWidgetModal = this;
        vmWidgetModal.learnTitle = $modalInstance.learnTitle;
        vmWidgetModal.textBodyParagraphs = $modalInstance.textBody.split('\n');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement', [
            'angularMoment', // angular-moment, requires moment
            'app.auth'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(config);

    config.$inject = ['$stateProvider', '$urlRouterProvider'];

    function config($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            // Check if a service ticket is present in the current url's search parameters.
            .when(/\\*/, ticketHandler)
            // Determine where to reroute the user when they navigate to '/'.
            .when('/', defaultPathRedirect);

        $stateProvider
            .state('accountManagement', {
                templateUrl: 'app/components/accountManagement.view.html',
                controller: 'AccountManagementController',
                controllerAs: 'vm'
            })
            .state('about', {
                url: '/about',
                templateUrl: 'app/components/accountManagement.view.html',
                controller: 'AccountManagementController',
                controllerAs: 'vm'
            });

        ticketHandler.$inject = ['$cookies', '$state', '$modal', 'authentication', '$location', 'Idle', 'config'];

        function ticketHandler($cookies, $state, $modal, authentication, $location, Idle, config) {
            var searchParms = $location.search();

            // Check if a service ticket is present in the current url's search parameters. If not, continue handling route as normal.
            if (angular.isDefined(searchParms.ticket)) {
                var ticket = searchParms.ticket;
                return config.get().then(function (configData) {
                    return authentication.logIn(ticket).then(function (response) {

                        Idle.watch();

                        $cookies.remove('logged-out-reason');

                        var options = {
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false
                        };

                        // Check if the user logged in with a one-time password or a password that is soon to expire. If so, display a modal with the appropriate warning.
                        if (response.isOneTimeUsePassword) {
                            options.templateUrl = 'app/components/dashboard/editPassword.view.html';
                            options.controller = 'EditPasswordController';
                            options.resolve = {
                                isDismissible: function () {
                                    return false;
                                }
                            };
                            options.id = 1;
                            $modal.open(options)
                                .result.then(function () {
                                    // Same as dashboard.controller.js - onClickEditPassword()
                                    $cookies.put('logged-out-reason', "Password successfully changed! Please log in again with your new credentials.");

                                    return emailPasswordChangeLogOut();
                                });
                        // If password is near expiration, alert user. If using Common Access Card (CAC), don't bother.
                        // Days to expire field should also not be null if using the modal. (Previously this was the only way to determine CAC use.)
                        } else if (!response.cac_in_use && (response.daysToExpire !== null) && (response.daysToExpire < configData.passwordExpirationWarningDays)) {
                            options.templateUrl = 'app/components/logIn/passwordExpirationModal/passwordExpirationModal.view.html';
                            options.controller = 'PasswordExpirationModalController';
                            options.resolve = {
                                daysRemaining: function () {
                                    return response.daysToExpire;
                                }
                            };
                            options.size = 'tiny';
                            $modal.open(options);
                        }

                        $state.go('accountManagement.dashboard', null, { reload: true });
                    }).catch(function (err) {
                        console.error(err);
                        // Reroute the user to the logged out page and display the appropriate error.
                        $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                        $state.go('accountManagement.loggedOut', null, { reload: true });
                    });
                });
            }
            return false;

            // Copied from dashboard.controller.js
            // TODO: not DRY
            function emailPasswordChangeLogOut() {
                var ticketErrorStr = "";

                return config.get().then(function (configData) {
                    ticketErrorStr = configData.loggedOutReasons.ticketError;
                })
                    // This function does most of logOut() except not log out of Core API,
                    // since that appears to be done by the API when changing email/password.
                    // This function should change URL, so only failure should return here?
                    .then(authentication.logOutCasOnly)
                    .catch(function (error) {
                        console.error(error);
                        $cookies.put('logged-out-reason', ticketErrorStr);
                    })
                    // This shouldn't happen, but just in case, send to AM logged out page.
                    .finally(function (response) {
                        $state.go('accountManagement.loggedOut');
                    });
            }
        }

        defaultPathRedirect.$inject = ['$cookies', '$state'];

        function defaultPathRedirect($cookies, $state) {
            $state.go('accountManagement.dashboard', null, { reload: true });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('AccountManagementController', AccountManagementController);

    AccountManagementController.$inject = ['Keepalive','$scope', '$cookies', '$state', '$modal', 'authentication', 'moment', 'Idle', 'config'];

    function AccountManagementController(Keepalive, $scope, $cookies, $state, $modal, authentication, moment, Idle, config) {
        var vm = this;

        vm.websiteFamilyList = null;
        vm.footerMessage = null;
        vm.isUatWebsite = null;
        vm.contactHelpDeskUrl = 'https://contact.armyfamilywebportal.com';

        vm.showMenu = false;

        vm.navClosed = false;

        vm.isLoggedIn = false;
        vm.lastLoginDate = null;

        vm.isAdmin = false;
        vm.isAfwpAdmin = false;

        vm.onClickLogOut = onClickLogOut;
        vm.onClickManageUsers = onClickManageUsers;
        vm.logIn = logIn;
        vm.register = register;
        vm.goHome = goHome;
        vm.onClickViewProfile = onClickViewProfile;
        vm.openAboutModal = openAboutModal;
        vm.toggleNav = toggleNav;

        $scope.$on('IdleStart', function () {
            // the user appears to have gone idle
            return $modal.open({
                templateUrl: 'app/components/idle/idle.view.html',
                controller: 'IdleController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'tiny',
                closeOnClick: false,
                keyboard: false
            }).result.then(function () {
                Idle.watch();
                $cookies.remove('logged-out-reason');
            });
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            config.get().then(function (configData) {
                $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                logOutOfAppOnly();
                $state.go('accountManagement.loggedOut', null, { reload: true });
            });
        });

        $scope.$on('Keepalive', function () {
            // do something to keep the user's session alive
            authentication.keepAlive().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                    logOut();
                });
            });
        });

        vm.classList = [
            'afwp-home',
            'efmp-blue',
            'acs-green',
            'vmis-teal',
            'ims-red',
            'olms-orange',
            'vfrg-blue'];

        for (var website in vm.websiteFamilyList) {
            vm.websiteFamilyList[website].color = vm.classList[website];
        }

        $scope.$on('profile:update', function () {
            // Update the name and side nav options
            activate();
        });

        // TODO: Reimplement Idle service triggers, if needed.

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.websiteFamilyList = configData.afwpWebsiteFamilyList;
                vm.footerMessage = configData.footerMessage || "";
                vm.isUatWebsite = configData.isUatWebsite;

                let options = vm.websiteFamilyList
                    .filter(e => e.name === 'AFWP Resource Center')
                    .map(e => e.url);

                // If "/about", open About modal on blank page that can't be closed.
                if ($state.current.name === 'about') {
                    openAboutModal(true);
                }
                else if (authentication.isLoggedIn() && $state.current.name !== 'accountManagement.loggedOut') {
                    vm.isLoggedIn = true;

                    authentication.getCasInfoForUser(authentication.getEmail()).then(function (casInfo) {
                        vm.isAdmin = casInfo.user.admin;
                    }).then(authentication.getUserProfile).then(function (userInfo) {
                        vm.firstName = userInfo.aosUser.firstName;
                        for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                            if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                                vm.isAfwpAdmin = true;
                            }
                        }
                        //Changing timeout based on admin
                        if(vm.isAdmin || vm.isAfwpAdmin){
                            Idle.setIdle(configData.adminIdleConfig.idle);
                            console.log('admin')
                            // Seconds to wait after a user is idle to perfom some action (e.g. log out the user).
                            Idle.setTimeout(configData.adminIdleConfig.timeout);
                            // Interval to send a keep alive signal to the backend.
                            Keepalive.setInterval(configData.adminIdleConfig.keepAlive);
                        }
                        else{
                            console.log('not admin')
                            // Seconds to wait until a user is considered idle.
                            Idle.setIdle(configData.idleConfig.idle);
                            // Seconds to wait after a user is idle to perfom some action (e.g. log out the user).
                            Idle.setTimeout(configData.idleConfig.timeout);
                            // Interval to send a keep alive signal to the backend.
                            Keepalive.setInterval(configData.idleConfig.keepAlive);
                        }
                    });
                    getLastLoginDate().catch(function (error) {
                        console.log(error);
                    });
                }
                else {
                    vm.isLoggedIn = false;
                }

                vm.isLoading = false;
            });
        }

        function onClickManageUsers() {
            manageUsers();
        }

        function getLastLoginDate() {
            return authentication.getLastLoginDate()
                .then(function (response) {
                    if (response.lastLoginDate == null){
                        vm.lastLoginDate = null;
                    } else {
                        vm.lastLoginDate = moment(response.lastLoginDate).local().format('MM-DD-YYYY, h:mm A');
                    }
                }).catch(function (err) {
                    throw(err);
                });
        }

        function onClickLogOut() {
            vm.isDropdownOpen = false;
            return logOut();
        }

        function logOut() {
            Idle.unwatch();
            authentication.logOut().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                });
            });
        }

        function logOutOfAppOnly() {
            Idle.unwatch();
            authentication.logOutOfAppOnly().catch(function (err) {
                console.error(err);
                return config.get().then(function (configData) {
                    $cookies.put('logged-out-reason', configData.loggedOutReasons.idle);
                });
            });
        }

        function onClickViewProfile() {
            vm.isDropdownOpen = false;
            $state.go('accountManagement.profile');
        }

        function goHome() {
            $state.go('accountManagement.dashboard');
        }

        function logIn() {
            $state.go('accountManagement.logIn');
        }

        function register() {
            return $state.go('accountManagement.register', null, { reload: true });
        }

        function manageUsers() {
            return $state.go('accountManagement.manageUsers', null, { reload: true });
        }

        // Close the dropdown menu if the user clicks outside of it
        window.onclick = function (event) {
            if (!$(event.target).hasClass("header-icon-menu")) {
                vm.showMenu = false;
                $scope.$apply();
            }
        };

        function openAboutModal(stayOpen) {
            var options = {
                templateUrl: "app/components/about/about.modal.view.html",
                controller: 'AboutModalController',
                controllerAs: 'aboutModal',
                backdrop: 'static',
                keyboard: 'false',
                show: true,
                resolve: {
                    // Tell modal to hide close buttons
                    stayOpen: function () {
                        return stayOpen;
                    }
                }
            };

            // Keep modal open despite clicks or "Escape" press
            if (stayOpen === true) {
                options.backdrop = 'static';
                options.keyboard = false;
            }

            return $modal.open(options)
                .result.catch(function (error) {
                    if (error === 'cancel' || error === 'ok' || error === 'backdrop click')
                        return;
                    if (error)
                        console.error(error);
                });
        }

        /* This function is accessible by a round button when the side nav is closed
        * and the last side nav entry when it is open.
        * The side nav entry only shows when on medium or small screens, and the side nav
        * always starts open. So this functionality isn't accessible on large screens.
        * (This can be changed! Just remove "hide-for-large" for that entry in accountManagement.view.html.) */
        function toggleNav() {
            vm.navClosed = !vm.navClosed;
        }
    }
})();
/**
 * Created by kmorgan41 on 12/12/16.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('userController', userController);

    userController.$inject = ['authentication', '$scope'];

    function userController(authentication, $scope) {

        $scope.dropdownContents = [];

        $scope.loggedIn = authentication.isLoggedIn();

        if($scope.loggedIn) {
            authentication.getUserProfile()
                .then(function (response) {
                    $scope.firstName = response.aosUser.firstName;

                    $scope.userName = {
                        name: 'Username',
                        //value: 'some very very very long name'
                        value: $scope.firstName
                    };

                    $scope.logout = {
                        name: 'Logout',
                        value: 'Log Out'
                    };
                    $scope.dropdownContents.push($scope.userName, $scope.logout);
                    //console.log($scope.dropdownContents);

                    $scope.selectedItem = $scope.userName;

                    $scope.$watch("selectedItem", function (value) {
                        if ($scope.selectedItem.name == "Logout") {
                            //$scope.logout();
                            //console.log('log out');
                        }
                    });
                });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('AboutModalController', AboutModalController);

    AboutModalController.$inject = ['$modalInstance', '$q', 'authentication', 'config', 'stayOpen'];

    function AboutModalController($modalInstance, $q, authentication, config, stayOpen) {
        var vm = this;
        vm.title = "About Account Management";

        vm.isLoading = true;

        vm.stayOpen = stayOpen;

        vm.amUi = {
            display: false,
            version: "-",
            date: "-",
            url: "",
            numericalVersion: "-"
        };
        vm.coreApi = {
            version: "-",
            online: false
        };
        vm.cas = {
            version: "-",
            online: false
        };

        var promises = [];

        promises.push(config.get().then(function (configData) {
            vm.amUi = configData.build;
            vm.amUi.numericalVersion = APP_VERSION; // From app/common/version.js
        }));

        // Get Core API version through check_health

        promises.push(authentication.checkCoreApiHealth(["cas"]).then(function (healthData) {
            vm.coreApi.version = healthData.apiVersion;
            vm.coreApi.online = healthData.success;
            vm.cas.online = healthData.CAS.healthy;
        }));

        // Get SSO (CAS) version through custom endpoint

        // Note: Could use success here as CAS being "online" instead of above health check
        promises.push(authentication.checkSsoHealth().then(function (version) {
            vm.cas.version = version.version;
        }));

        $q.all(promises).catch(function (error) {
            console.error(error);
        }).finally(function () {
            vm.isLoading = false;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.verify', {
                url: '/verify',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.reset-password-token', {
                url: '/reset-password-token',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.request-verification-email', {
                url: '/request-verification-email',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['authentication', '$modal', '$timeout', '$window', '$cookies', '$state', 'config'];

    function DashboardController(authentication, $modal, $timeout, $window, $cookies, $state, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isLoggedIn = false;
        vm.formError = "";
        vm.formSuccess = "";

        vm.onClickEditEmail = onClickEditEmail;
        vm.onClickEditPassword = onClickEditPassword;
        vm.onClickConnectCAC = onClickConnectCAC;
        vm.onClickRemoveCAC = onClickRemoveCAC;
        vm.onClickVerifyAccount = onClickVerifyAccount;
        vm.onClickRequestVerificationEmail = onClickRequestVerificationEmail;
        vm.onClickEnterResetToken = onClickEnterResetToken;

        activate();

        function activate() {
            if (authentication.isLoggedIn()) {
                vm.isLoggedIn = true;
                vm.email = authentication.getEmail();
                var cacInfo = authentication.getCacInfo();
                vm.cacRegistered = cacInfo.registered === "true";
                vm.cacInUse = cacInfo.inUse === "true";
            }
            else {
                vm.isLoggedIn = false;
                vm.email = null;

                // If "/verify", open Verify modal initially
                if ($state.current.name === 'accountManagement.verify') {
                    vm.onClickVerifyAccount();
                }

                if ($state.current.name === 'accountManagement.reset-password-token') {
                    vm.onClickEnterResetToken();
                }

                if ($state.current.name === 'accountManagement.request-verification-email') {
                    vm.onClickRequestVerificationEmail();
                }
            }
            vm.isLoading = false;
        }

        function onClickEditEmail() {
            $modal.open({
                templateUrl: 'app/components/dashboard/editEmail.view.html',
                controller: 'EditEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    email: function () {
                        return vm.email;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Email updated successfully! Logging you out...';

                $cookies.put('logged-out-reason', "Email successfully changed! Please log in again with your new credentials.");

                return emailPasswordChangeLogOut();
            });
        }

        function onClickEditPassword() {
            $modal.open({
                templateUrl: 'app/components/dashboard/editPassword.view.html',
                controller: 'EditPasswordController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isDismissible: function () {
                        return true;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Password updated successfully! Logging you out...';

                $cookies.put('logged-out-reason', "Password successfully changed! Please log in again with your new credentials.");

                return emailPasswordChangeLogOut();
            });
        }

        function onClickVerifyAccount() {
            $modal.open({
                templateUrl: 'app/components/verify/verify.view.html',
                controller: 'VerifyController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isVerifying: function () {
                        return true;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Email verified successfully!';
            });
        }

        function onClickRequestVerificationEmail() {
            $modal.open({
                templateUrl: 'app/components/verify/verify.view.html',
                controller: 'VerifyController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isVerifying: function () {
                        return false;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Verification email sent successfully!';
            });
        }

        function onClickEnterResetToken() {
            $modal.open({
                templateUrl: 'app/components/resetToken/resetToken.view.html',
                controller: 'ResetTokenController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false'
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Token accepted!';
            });
        }

        function emailPasswordChangeLogOut() {
            vm.isLoading = true;

            var ticketErrorStr = "";

            return config.get().then(function (configData) {
                ticketErrorStr = configData.loggedOutReasons.ticketError;
            })
                // This function does most of logOut() except not log out of Core API,
                // since that appears to be done by the API when changing email/password.
                // This function should change URL, so only failure should return here?
                .then(authentication.logOutCasOnly)
                .catch(function (error) {
                    console.error(error);
                    $cookies.put('logged-out-reason', ticketErrorStr);
                })
                // This shouldn't happen, but just in case, send to AM logged out page.
                .finally(function (response) {
                    $state.go('accountManagement.loggedOut');
                });
        }

        function onClickConnectCAC() {
            vm.isLoading = true;

            authentication.getCacInfoFromCard().then(function (cacInfo) {
                return authentication.getProxyTicket().then(function (response) {
                    return config.get().then(function (configData) {
                        let url = configData.casUserAdmin;

                        if (cacInfo && cacInfo.cacId && cacInfo.iv && cacInfo.subjectDN) {
                            url += 'rest/addCacWithCert'
                                + '?service=' + encodeURIComponent($window.location.href)
                                + '&pt=' + encodeURIComponent(response.proxyTicket)
                                + '&cacId=' + encodeURIComponent(cacInfo.cacId)
                                + '&subjectDN=' + encodeURIComponent(cacInfo.subjectDN)
                                + '&iv=' + encodeURIComponent(cacInfo.iv);
                        } else {
                            url += 'rest/addCac'
                                + '?service=' + encodeURIComponent($window.location.href)
                                + '&pt=' + encodeURIComponent(response.proxyTicket);
                        }

                        $window.location.href = url;
                        vm.isLoading = false;
                    });
                });
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = error;
                vm.isLoading = false;
            });
        }

        function onClickRemoveCAC() {
            vm.isLoading = true;
            authentication.getProxyTicket().then(function (response) {
                return config.get().then(function (configData) {
                    $window.location.href = configData.casUserAdmin + 'rest/removeCac?service=' + $window.location.href + '&pt=' + response.proxyTicket;
                    vm.isLoading = false;
                });
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = error;
                vm.isLoading = false;
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditEmailController', EditEmailController);

    EditEmailController.$inject = ['$modalInstance', 'email', 'authentication'];

    function EditEmailController($modalInstance, email, authentication) {
        var vm = this;

        vm.email = email;

        vm.onSubmit = onSubmit;

        function onSubmit() {
            authentication.changeLoginEmail({
                identifier: vm.email,
                email: vm.newEmail
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditPasswordController', EditPasswordController);

    EditPasswordController.$inject = ['$window', '$modalInstance', 'authentication', 'isDismissible', 'config'];

    function EditPasswordController($window, $modalInstance, authentication, isDismissible, config) {
        var vm = this;

        vm.onSubmit = onSubmit;
        vm.isDismissible = isDismissible;
        vm.passwordRequirements = null;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.passwordRequirements = configData.passwordRequirements;
            });
        }

        function onSubmit() {
            authentication.changeLoginPassword({
                password: vm.newPassword
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
            });
        }
    }
})();
/**
 * Created by scuzzort3 on 7/31/17.
 */
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.hierarchy', {
                url: '/hierarchy',
                controller: 'HierarchyController',
                controllerAs: 'vm',
                templateUrl: 'app/components/hierarchy/hierarchy.view.html'
            });
    }
})();
/**
 * Created by scuzzort3 on 7/31/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('HierarchyController', HierarchyController);

    HierarchyController.$inject = ['$modal'];

    function HierarchyController($modal) {
        var vm = this;
        vm.onCommunityClicked = onCommunityClicked;
        vm.onAddChildClicked = onAddChildClicked;
        vm.communitySearchText = "";
        vm.refreshCommunityList = false;
        vm.showHierarchy = false;

        function onCommunityClicked(communityNode) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/hierarchy/addOrEditChildModal.template.html',
                controller: 'EditChildModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    communityNode: function () {
                        return communityNode;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.refreshCommunityList = true;
            });
        }

        function onAddChildClicked(communityNode) {
            var modalInstance = $modal.open({
                templateUrl: 'app/components/hierarchy/addOrEditChildModal.template.html',
                controller: 'EditChildModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    communityNode: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.refreshCommunityList = true;
            });
        }
    }
})();
/**
 * Created by scuzzort3 on 8/14/17.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditChildModalController', EditChildModalController);

    EditChildModalController.$inject = ['$modalInstance', '$scope', 'authentication', 'communityNode', '$modal'];

    function EditChildModalController($modalInstance, $scope, authentication, communityNode, $modal) {
        var vm = this;

        vm.isNewCommunityModal = true;
        vm.communityId = null;
        vm.originalParentId = null;
        vm.parentId = null;
        vm.parentName = "";
        vm.oldParentName = vm.parentName;
        vm.communityName = "";
        vm.isRegion = false;
        vm.isArchived = false;
        vm.hasChildren = false;
        vm.modalTitle = "Add New Community";
        vm.modalHelp = "Note: Changes to a community's region or directorate must be requested through IMCOM, and IMCOM must approve the change before the change can be made.";

        if (communityNode !== null) {
            vm.isNewCommunityModal = false;
            vm.modalHelp = "Making a region node inactive will cause all communities within that region to become inactive.";
            vm.modalTitle = "Edit Community - " + communityNode.value;
            vm.communityId = communityNode.id;
            vm.hasChildren = communityNode.children.length > 0;
            vm.isRegion = communityNode.isLeaf === 0;
            vm.isArchived = communityNode.isArchived === 1;
            vm.communityName = communityNode.value;
            if (communityNode.parent !== null) {
                vm.parentName = communityNode.parent.value;
                vm.parentId = communityNode.parent.id;
                vm.originalParentId = vm.parentId;
                vm.oldParentId = communityNode.parent.id;
                vm.oldParentName = communityNode.parent.value;
            }
        }
        else {
            vm.showHierarchy = true;
        }

        vm.enableSave = false;
        vm.parentIsArchived = false;

        if (communityNode !== null && vm.parentId !== null && communityNode.parent.isArchived === 1) {
            vm.isArchived = true;
            vm.parentIsArchived = true;
        }

        updateInactive();

        if (vm.hasChildren === true) {
            vm.isRegion = true;
        }

        vm.okEnabled = false;
        vm.onCancel = onCancel;
        vm.onSubmit = onSubmit;
        vm.onCommunityClicked = onCommunityClicked;
        vm.onCommunityCancelled = onCommunityCancelled;
        vm.checkCanSave = checkCanSave;

        function updateInactive() {
            vm.disableInactive = (vm.parentId === null && vm.communityId !== null) || vm.parentIsArchived;
        }

        function onCommunityClicked(clickedNode) {
            vm.parentId = clickedNode.id;
            vm.parentName = clickedNode.value;

            vm.oldParentName = clickedNode.value;
            vm.originalParentId = clickedNode.id;

            vm.showHierarchy = false;

            if (clickedNode.isArchived === 1) {
                vm.isArchived = true;
                vm.parentIsArchived = true;
            }
            else {
                vm.parentIsArchived = false;
            }

            updateInactive();

            vm.checkCanSave();
        }

        function onCommunityCancelled() {
            vm.showHierarchy = false;

            vm.parentId = vm.originalParentId;
            vm.parentName = vm.oldParentName;
        }

        function checkCanSave() {
            vm.enableSave = vm.communityName.length > 0 && vm.parentId !== null;
        }

        function displayError(error) {
            vm.formError = error;
        }

        function onCancel() {
            $modalInstance.dismiss('cancel');
        }

        function onSubmit() {
            var isLeafVal = 1;
            if (vm.isRegion === true) {
                isLeafVal = 0;
            }

            var isArchivedVal = 0;
            if (vm.isArchived === true) {
                isArchivedVal = 1;
            }

            var data = {
                id: vm.communityId,
                isArchived: isArchivedVal,
                name: vm.communityName,
                isLeaf: isLeafVal,
                communityParentId: vm.parentId};

            if (vm.isNewCommunityModal === true) {
                authentication.addCommunityInTree(data)
                    .then(function (result) {
                        $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                    })
                    .catch(displayError);
            }
            else {
                if (!communityNode.isArchived && data.isArchived) {
                    var modalInstance = $modal.open({
                        templateUrl: 'app/components/hierarchy/confirmCommunityInactive.template.html',
                        controller: 'ConfirmCommunityInactiveController',
                        controllerAs: 'vm',
                        resolve: {
                            community: function () {
                                return vm.communityName;
                            },
                            title: function () {
                                return "Inactivate Community";
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        return authentication.changeCommunityInTree(data)
                            .then(function (result) {
                                $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                                // TODO: Move this VMIS-specific functionality elsewhere
                                /*
                                return authentication.inactivateCommunity({communityAffiliationId: vm.communityId})
                                    .then(function (result){
                                        $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                                    });
                                */
                            })
                            .catch(displayError);
                    });
                }

                else {
                    authentication.changeCommunityInTree(data)
                        .then(function (result) {
                            $modalInstance.close({communityName: vm.communityName, isLeaf: vm.isLeaf});
                        })
                        .catch(displayError);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConfirmCommunityInactiveController', ConfirmCommunityInactiveController);

    ConfirmCommunityInactiveController.$inject = ['$modalInstance', 'title', 'community'];

    function ConfirmCommunityInactiveController($modalInstance, title, community) {
        var vm = this;
        vm.title = title;

        if (community !== null) {
            vm.name = community;
        }

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.loginStats', {
                url: '/login-stats',
                templateUrl: 'app/components/loginStats/loginStats.view.html',
                controller: 'LoginStatsController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('LoginStatsController', LoginStatsController);

     LoginStatsController.$inject = ['authentication','$window','moment'];

     function LoginStatsController (authentication,$window,moment) {
         var vm = this;

         vm.isLoading = true;
         vm.isAfwpAdmin = false;
         vm.isDataLoaded = false;
         vm.loginCount = {};
         vm.loginCount.services = {};
         vm.currentDate = new Date();
         vm.startDate = moment().subtract(6, 'months').toISOString();
         vm.endDate = new Date().toISOString();
         vm.decodeUrl = decodeUrl;
         vm.onClickSearch = onClickSearch;


         activate();

         function activate() {
             authentication.getUserProfile().then(function(userInfo) {
                 for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                     if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                         vm.isAfwpAdmin = true;
                     }
                 }
                 // if(vm.isAfwpAdmin){
                 //     authentication.getLoginStats("2023-08-01").then(function(loginStats){
                 //         vm.loginCount = loginStats;
                 //     });
                 // }
                 vm.isLoading = false;
             });
         }

         function decodeUrl(url) {
             return $window.decodeURIComponent(url);
         }

         function onClickSearch(startDate,endDate) {
             vm.isLoading = true;
             if(vm.isAfwpAdmin){
                 authentication.getLoginStats(startDate,endDate).then(function(loginStats){
                     vm.loginCount = loginStats;
                 });
             }
             vm.isDataLoaded = true;
             vm.isLoading = false;
         }
     }

})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.manageUsers', {
                url: '/manage-users',
                templateUrl: 'app/components/manageUsers/manageUsers.view.html',
                controller: 'ManageUsersController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManageUsersController', ManageUsersController);

    ManageUsersController.$inject = ['authentication','$modal','$state','$q','config','$window'];

    function ManageUsersController(authentication,$modal,$state,$q,config,$window) {
        var vm = this;

        vm.isLoading = true;
        vm.isWaiting = false; // Used for disabling all buttons when one is pressed
        vm.formSuccess = "";
        vm.formError = "";
        vm.displayInfoWhenErrored = false;

        vm.onClickDashboard = onClickDashboard;
        vm.onSearchAllUsers = onSearchAllUsers;
        vm.onSearchUser = onSearchUser;
        vm.onSearchUserCAS = onSearchUserCAS;
        vm.onSearchUserAFWP = onSearchUserAFWP;
        vm.onEnable = onEnable;
        vm.setAccountDisabled = setAccountDisabled;
        vm.onPasswordReset = onPasswordReset;
        vm.onManageUserEmail = onManageUserEmail;
        vm.onAdminEditing = onAdminEditing;
        vm.onClickRemoveCAC = onClickRemoveCAC;
        vm.onAFWPAdminEditing = onAFWPAdminEditing;
        vm.onCheckActivity = onCheckActivity;
        vm.currentEmail = "";
        vm.isEmpty = true;
        vm.isAccountEnableable = false;
        vm.isAccountDisabled = false;
        vm.isDisabledDueToPw = false;
        vm.isDisabledDueToInactivity = false;
        vm.isAccountAdmin = false;
        vm.isAccountAFWPAdmin = null;
        vm.manageUserEmailText = "Edit User Email";
        vm.adminButtonText = "Make CAS Admin";
        vm.afwpAdminButtonText = "Make AFWP Admin";
        vm.isAdmin = false;
        vm.isAfwpAdmin = false;
        vm.doesUserExistInAFWP = false;
        vm.searchResult =
            {
                casId: null,
                lastActive: null,
                admin: null,
                verified: null,
                disableDate: null,
                isCacRegistered: null
            };
        vm.searchResults = [];
        vm.searchString = "";
        vm.searchEmail = "";
        vm.currentStatus = "";
        vm.passwordAttemptsThreshold = null;
        vm.numberOfDaysUntilInactive = null;
        vm.tempPassword = "";
        vm.resetPassword = false;

        activate();

        function activate() {
            authentication.getCasInfoForUser(authentication.getEmail())
                .then(function (casInfo) {
                    vm.isAdmin = casInfo.user.admin;
                    vm.currentEmail = casInfo.user.email;

                    config.get().then(function(configData){
                        vm.passwordAttemptsThreshold = configData.cas.failedPasswordCount;
                        vm.numberOfDaysUntilInactive = configData.cas.numberOfDaysUntilInactive;
                        authentication.getUserProfile().then(function(userInfo){
                            for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                                if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                                    vm.isAfwpAdmin = true;
                                }
                            }
                            vm.isLoading = false;
                        });
                    });
                })
                .catch(function (error) {
                    // Fixes endless loading by catching the error for logged out users and setting appropriate flags to false.
                    vm.isAfwpAdmin = false;
                    vm.isAdmin = false;
                    vm.isLoading = false;
                });
        }

        function onClickDashboard() {
            return $state.go('accountManagement.dashboard', null, { reload: true });
        }

        function onSearchAllUsers() {
            if(!vm.searchString){
                vm.searchEmail = "";
                vm.searchResults=[];
            }

            if(vm.isAdmin){
                return getAllCasUsers()
                    .then(function(){
                        onSearchUser();
                    });
            }
            else {
                onSearchUser();
            }
        }

        function onSearchUser() {

            vm.formError = "";
            vm.displayInfoWhenErrored = false;

            if(vm.isAdmin && vm.isAfwpAdmin){

                return onSearchUserCAS()
                    .then(function(){
                        vm.displayInfoWhenErrored = true;
                    })
                    .catch(function(err){
                        vm.formError = err;
                    })
                    .finally(function(){
                        return onSearchUserAFWP()
                            .then(function(){
                                vm.displayInfoWhenErrored = true;
                            })
                            .catch(function(err){
                                if (vm.formError.length > 0) {
                                    vm.formError += ". ";
                                }
                                vm.formError += err;
                            });
                    });
            }

            else if(vm.isAdmin){
                return getAllCasUsers()
                    .then(function(){
                        return onSearchUserCAS()
                            .then(function () {
                                vm.displayInfoWhenErrored = true;
                            })
                            .catch(function (err) {
                                vm.formError = err;
                            });
                });
            }

            else if(vm.isAfwpAdmin){
                vm.searchEmail = vm.searchString;
                return onSearchUserAFWP()
                    .then(function(){
                        vm.displayInfoWhenErrored = true;
                    })
                    .catch(function(err){
                    vm.formError = err;
                });
            }

        }

        function getAllCasUsers() {

            return authentication.getCasInfoForUsers(vm.searchString)
                .then(function (casInfo) {
                    vm.searchResults = casInfo.users;
                    if(casInfo.users.length > 0) {
                        casInfo.users[0].isChecked = true;
                        vm.searchEmail = casInfo.users[0].email;
                    }
                    else {
                        vm.searchEmail = "";
                    }
                })
                .catch(function (error) {
                    vm.searchResult.casId = null;
                    vm.searchResult.lastActive = null;
                    vm.searchResult.admin = null;
                    vm.searchResult.email = null;
                    vm.searchResult.verified = null;
                    vm.searchResult.disableDate = null;
                    vm.searchResult.lastFailedLoginDate = null;
                    vm.searchResult.deleted = null;
                    vm.searchResult.failedPasswordCount = null;
                    vm.searchResult.isCacRegistered = null;
                    vm.searchResult.lastLoginTime = null;
                    vm.searchResult.lastLoginMethod = null;
                    vm.searchResult.createdDate = null;
                    vm.isEmpty = true;
                    vm.isAccountDisabled = false;
                    vm.isAccountEnableable = false;
                    vm.disabledDueToPw = false;
                    vm.disabledDueToInactivity = false;
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address or partial email does not exist in CAS";
                    });

        }

        function onSearchUserCAS() {
            vm.currentStatus = "";
            return authentication.getCasInfoForUser(vm.searchEmail)
                .then(function (casInfo) {
                    vm.searchResult.casId = casInfo.user.id ? casInfo.user.id : "none";
                    vm.searchResult.lastActive = casInfo.user.lastSuccessfulLogin ? moment(casInfo.user.lastSuccessfulLogin).format('lll') : "none";
                    vm.searchResult.admin = casInfo.user.admin ? casInfo.user.admin : false;
                    vm.searchResult.deleted = casInfo.user.deleted ? casInfo.user.deleted : false;
                    vm.searchResult.email = casInfo.user.email ? casInfo.user.email : "none";
                    vm.searchResult.verified = casInfo.user.emailVerified ? casInfo.user.emailVerified : false;
                    vm.searchResult.disableDate = casInfo.user.disableDate ? moment(casInfo.user.disableDate).format('lll') : "none";
                    vm.searchResult.lastFailedLoginDate = casInfo.user.lastFailedLoginDate ? moment(casInfo.user.lastFailedLoginDate).format('lll') : "none";
                    vm.searchResult.lastLoginTime = casInfo.user.lastLoginTime ? moment(casInfo.user.lastLoginTime).format('lll') : "none";
                    vm.searchResult.createdDate = casInfo.user.createdDate ? moment(casInfo.user.createdDate).format('lll') : "none";
                    vm.searchResult.lastLoginMethod = casInfo.user.lastLoginMethod ? casInfo.user.lastLoginMethod : "none";
                    vm.searchResult.failedPasswordCount = isNaN(casInfo.user.failedPasswordCount) ? "none": casInfo.user.failedPasswordCount;
                    vm.searchResult.isCacRegistered = casInfo.user.cacid === "yes";
                    vm.isEmpty = isEmpty();
                    vm.isAccountDisabled = isAccountDisabled();
                    vm.isDisabledDueToPw = isDisabledDueToPW();
                    vm.isDisabledDueToInactivity = isDisabledDueToInactivity();
                    vm.isAccountAdmin = isAccountAdmin();
                    vm.adminButtonText = vm.isAccountAdmin?"Remove CAS Admin":"Make CAS Admin";
                    vm.isWaiting = false;


                    if(vm.searchResult.deleted){
                        vm.currentStatus = "Deleted";
                        vm.isAccountEnableable = true;
                    }

                    else {
                        if (!vm.isAccountDisabled && !vm.isDisabledDueToPw && !vm.isDisabledDueToInactivity) {
                            vm.currentStatus = "Enabled";
                            vm.isAccountEnableable = false;
                        }

                        else {
                            vm.isAccountEnableable = true;

                            vm.currentStatus = "Disabled due to: " + (vm.isAccountDisabled ? 'admin ' : "") + (vm.isDisabledDueToPw ? 'password attempts ' : "") +
                                (vm.isDisabledDueToInactivity ? ' inactivity' : "");

                        }
                    }

                })
                .catch(function (error) {
                    vm.searchResult.casId = null;
                    vm.searchResult.lastActive = null;
                    vm.searchResult.admin = null;
                    vm.searchResult.email = null;
                    vm.searchResult.verified = null;
                    vm.searchResult.disableDate = null;
                    vm.searchResult.lastFailedLoginDate = null;
                    vm.searchResult.deleted = null;
                    vm.searchResult.failedPasswordCount = null;
                    vm.searchResult.isCacRegistered = null;
                    vm.searchResult.lastLoginTime = null;
                    vm.searchResult.lastLoginMethod = null;
                    vm.searchResult.createdDate = null;
                    vm.isEmpty = true;
                    vm.isAccountDisabled = false;
                    vm.isAccountEnableable = false;
                    vm.disabledDueToPw = false;
                    vm.disabledDueToInactivity = false;
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address or partial email does not exist in CAS";
                });
        }

        function onSearchUserAFWP() {
            return authentication.getUserProfile(vm.searchEmail)
                .then(function(resultUser){
                    vm.isAccountAFWPAdmin = false;
                    for (var i = 0; i < resultUser.aosUser.aosRoles.length; i++) {
                        if (resultUser.aosUser.aosRoles[i] === "AFWP Administrator") {
                            vm.isAccountAFWPAdmin = true;
                        }
                    }
                    vm.isEmpty = isEmpty();
                    vm.doesUserExistInAFWP = true;
                    vm.afwpAdminButtonText = vm.isAccountAFWPAdmin?"Remove AFWP Admin":"Make AFWP Admin";
                    vm.isWaiting = false;
                })
                .catch(function(error){
                    vm.doesUserExistInAFWP = false;
                    vm.isAccountAFWPAdmin = null;
                    vm.afwpAdminButtonText = "Make AFWP Admin";
                    vm.isWaiting = false;
                    $('#manage-users-content')[0].scrollIntoView();
                    throw "A user with this email address does not exist in AFWP";
                });
        }

        function setAccountDisabled() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    if(!vm.isAccountDisabled){
                        return authentication.disableUser(vm.searchResult.email, proxyTicket.proxyTicket)
                            .then(function (result) {
                                return onSearchUser();
                            });
                    }
                })
                .catch(function (err) {
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onEnable() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    return authentication.resetUser(vm.searchResult.email, proxyTicket.proxyTicket)
                        .then(function (result) {
                            return onSearchUser();
                        });
                })
                .catch(function (err) {
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onPasswordReset() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {

                    $modal.open({
                        templateUrl: 'app/components/manageUsers/confirmPasswordReset.view.html',
                        controller: 'ConfirmPasswordResetController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        keyboard: 'false',
                        resolve: {
                            email: function () {
                                return vm.searchResult.email;
                            }
                        }
                    }).result.then(function () {
                        return authentication.resetPassword(vm.searchResult.email, proxyTicket.proxyTicket)
                                .then(function (result) {
                                    $modal.open({
                                        templateUrl: 'app/components/manageUsers/showTempPassword.view.html',
                                        controller: 'ShowTempPasswordController',
                                        controllerAs: 'vm',
                                        backdrop: 'static',
                                        keyboard: 'false',
                                        resolve: {
                                            email: function () {
                                                return vm.searchResult.email;
                                            },
                                            tempPassword: function () {
                                                return result.id;
                                            }
                                        }
                                    }).result.then(function () {});
                                    return onSearchUser();
                                });
                        })
                        .catch(function (err) {
                            vm.isWaiting = false;
                            vm.formError = err;
                            vm.displayInfoWhenErrored = true;
                            return onSearchUser();
                        });
                    });
                    return onSearchUser();
        }

        function onManageUserEmail() {
            $modal.open({
                templateUrl: 'app/components/manageUsers/manageUsersEmail.view.html',
                controller: 'ManageUsersEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    email: function () {
                        return vm.searchResult.email;
                    }
                }
            }).result.then(function () {
                // vm.formError = '';
                // vm.formSuccess = '';
            });
        }

        function onAdminEditing() {
            vm.isWaiting = true;
            authentication.getProxyTicket()
                .then(function (proxyTicket) {
                    return authentication.setAdminStatus(vm.searchResult.email,vm.isAccountAdmin,proxyTicket.proxyTicket)
                        .then(function (result) {
                            return onSearchUser();
                        })
                        .catch(function(err){
                            vm.isWaiting = false;
                            vm.formError = err;
                            vm.displayInfoWhenErrored = true;
                            return onSearchUser();
                        });
                })
                .catch(function(err){
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return onSearchUser();
                });
        }

        function onClickRemoveCAC() {
            vm.isWaiting = true;
            authentication.getProxyTicket().then(function (response) {
                return config.get().then(function (configData) {
                    $window.location.href = configData.casUserAdmin + 'rest/removeCac?service=' + $window.location.href + '&pt=' + response.proxyTicket +'&userEmail='+ vm.searchResult.email;
                    vm.isWaiting = false;
                });
            }).catch(function (error) {
                vm.isWaiting = false;
                vm.formError = error;
                vm.displayInfoWhenErrored = true;
            });
        }

        function onCheckActivity(position,results) {
            angular.forEach(results,function(resultSet,index){
                if(position != index){
                    resultSet.isChecked = false;
                }
            });
            vm.searchEmail = results[position].email;
            onSearchUser();

        }

        function onAFWPAdminEditing() {
            vm.isWaiting = true;
            return authentication.setAdminStatusAFWP(vm.searchEmail,vm.isAccountAFWPAdmin)
                .then(function(result){
                    return onSearchUser();
                })
                .catch(function(err){
                    vm.isWaiting = false;
                    vm.formError = err;
                    vm.displayInfoWhenErrored = true;
                    return;
                });
        }

        function isEmpty() {
            if(vm.isAfwpAdmin && vm.isAdmin) {
                return (vm.isAccountAFWPAdmin === null && vm.searchResult.casId === null && vm.searchResult.lastActive === null && vm.searchResult.email === null && vm.searchResult.admin === null && vm.searchResult.verified === null &&
                     vm.searchResult.disableDate === null && vm.searchResult.lastFailedLoginDate === null && vm.searchResult.deleted === null && vm.searchResult.failedPasswordCount === null && vm.searchResult.isCacRegistered == null &&
                     vm.searchResult.lastLoginTime == null && vm.searchResult.lastLoginMethod == null && vm.searchResult.createdDate == null);
            }

            else if(vm.isAfwpAdmin){
                return (vm.isAccountAFWPAdmin === null);
            }

            else if(vm.isAdmin){
                return (vm.searchResult.casId === null && vm.searchResult.lastActive === null && vm.searchResult.email === null && vm.searchResult.admin === null && vm.searchResult.verified === null && vm.searchResult.disableDate === null &&
                    vm.searchResult.lastFailedLoginDate === null && vm.searchResult.deleted === null && vm.searchResult.failedPasswordCount === null && vm.searchResult.isCacRegistered == null && vm.searchResult.lastLoginTime == null &&
                    vm.searchResult.lastLoginMethod == null && vm.searchResult.createdDate == null);
            }
        }

        function isAccountDisabled() {
            return (vm.searchResult.disableDate !== "none");
        }

        function isDisabledDueToPW() {
            return (vm.searchResult.failedPasswordCount > vm.passwordAttemptsThreshold);
        }

        function isDisabledDueToInactivity() {
            return ((moment(vm.searchResult.lastActive).add(vm.numberOfDaysUntilInactive,'days')) < moment());
        }

        function isAccountAdmin () {
            return (vm.searchResult.admin);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ManageUsersEmailController', ManageUsersEmailController);

    ManageUsersEmailController.$inject = ['$modalInstance', 'email', 'authentication'];

    function ManageUsersEmailController($modalInstance, email, authentication) {
        var vm = this;

        vm.email = email;

        vm.onSubmit = onSubmit;

        function onSubmit() {
            vm.isWaiting = true;
            authentication.changeLoginEmail({
                identifier: vm.email,
                email: vm.newEmail,
                adminEditing: true
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
                vm.isWaiting = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ShowTempPasswordController', ShowTempPasswordController);

        ShowTempPasswordController.$inject = ['$modalInstance', 'email', 'tempPassword', 'authentication'];

    function ShowTempPasswordController($modalInstance, email, tempPassword, authentication) {
        var vm = this;

        vm.tempPassword = tempPassword;
        vm.email = email;
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConfirmPasswordResetController', ConfirmPasswordResetController);

        ConfirmPasswordResetController.$inject = ['$modalInstance', 'email', 'authentication'];

    function ConfirmPasswordResetController($modalInstance, email, authentication) {
        var vm = this;

        vm.onAccept = onAccept;

        function onAccept() {
            $modalInstance.close();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.register', {
                url: '/register?{return-to}',
                templateUrl: 'app/components/register/register.view.html',
                controller: 'RegisterController',
                controllerAs: 'vm'
            })
            .state('accountManagement.registrationLanding', {
                url: '/registration-landing',
                templateUrl: 'app/components/register/registrationLanding.view.html'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['authentication', '$state', '$stateParams', 'config'];

    function RegisterController(authentication, $state, $stateParams, config) {
        var vm = this;

        vm.isLoading = false;

        vm.onSubmit = onSubmit;
        vm.logIn = logIn;
        vm.passwordRequirements = null;

        activate();

        function activate() {
            // Redirect to dashboard if already logged in.
            if (authentication.isLoggedIn()) {
                $state.go('accountManagement.dashboard');
            }

            config.get().then(function (configData) {
                vm.passwordRequirements = configData.passwordRequirements;
                vm.trainingNote = configData.isTrainingWebsite ?
                    "Do not enter personal data on this training site except a real, accessible email here." : "";
            });
        }

        function onSubmit(email, password) {
            vm.isLoading = true;

            vm.formError = "";

            var params = {
                email: email,
                password: password
            };
            authentication.register(params)
                .then(function () {
                    $state.go('accountManagement.registrationLanding', $stateParams);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    vm.formError = error;
                    vm.isLoading = false;
                });
        }

        function logIn() {
            $state.go('accountManagement.logIn');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('IdleController', IdleController);

    IdleController.$inject = ['$scope', '$modalStack', 'config'];

    function IdleController($scope, $modalStack, config) {
        var vm = this;
        vm.countdown = null;

        $scope.$on('IdleWarn', function (e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()

            $scope.$apply(function () {
                vm.countdown = countdown;
            });
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them

            return $modalStack.dismissAll();
        });

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.countdown = configData.idleConfig.timeout;
            });
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.loggedOut', {
                url: '/logged-out',
                templateUrl: 'app/components/loggedOut/loggedOut.view.html',
                controller: 'LoggedOutController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('LoggedOutController', LoggedOutController);

    LoggedOutController.$inject = ['$cookies','config','authentication'];

    function LoggedOutController($cookies,config,authentication) {
        var vm = this;

        // Show reason for being logged out if any
        vm.formError = $cookies.get('logged-out-reason');

        activate();

        function activate() {
            if(authentication.isLoggedIn()){
                vm.isLoading=true;
                var ticketErrorStr = "";

                return config.get().then(function (configData) {
                    ticketErrorStr = configData.loggedOutReasons.ticketError;
                }).then(authentication.logOut)
                .catch(function (error) {
                    console.error(error);
                    $cookies.put('logged-out-reason', ticketErrorStr);
                }).finally(vm.isLoading=false);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routes($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            .when('/log-in', logInRedirect);

        $stateProvider
            .state('accountManagement.logIn', {
                url: '/log-in',
                template: '<h1 class="center-horizontal">Redirecting to SSO Log-In...</h1>'
            });

        logInRedirect.$inject = ['$window', 'config'];

        function logInRedirect($window, config) {
            return config.get().then(function (configData) {
                $window.location.href = configData.casServer + 'login?service=' +
                    encodeURIComponent($window.location.protocol + "//" + $window.location.host);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('PasswordExpirationModalController', PasswordExpirationModalController);

    PasswordExpirationModalController.$inject = ['daysRemaining'];

    function PasswordExpirationModalController(daysRemaining) {
        var vm = this;

        vm.daysRemaining = daysRemaining;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.profile', {
                url: '/profile',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm'
            })
            .state('accountManagement.profileEdit', {
                url: '/profile/{id:int}',
                templateUrl: 'app/components/profile/profile.view.html',
                controller: 'ProfileController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['$anchorScroll', '$q', '$state', '$stateParams', '$scope', 'authentication', 'moment', '_', 'config'];

    function ProfileController($anchorScroll, $q, $state, $stateParams, $scope, authentication, moment, _, config) {
        var vm = this;
        var oldCommunity = {
            communityAffiliationId: null,
            communityAffiliationName: null
        };

        vm.phoneRegex = null;
        vm.isUatWebsite = null;
        vm.isTrainingWebsite = null;
        vm.isLoading = true;

        vm.roles = [];

        vm.dispositions = {};
        vm.dispositionsSelected = 0;
        vm.masterUserId = parseInt($stateParams.id) || null; // If exists, using page as admin
        vm.nonUserEmail = $stateParams.email || null; // If exists, using page to create non-user
        vm.fullName = vm.nonUserEmail || "";

        vm.noProfile = false;

        vm.onSubmit = onSubmit;
        vm.onCancel = onCancel;
        vm.onChangeDisposition = onChangeDisposition;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.phoneRegex = configData.phoneRegex;
                vm.isUatWebsite = configData.isUatWebsite;
                vm.isTrainingWebsite = configData.isTrainingWebsite;
            });
            fillDropDowns().then(getUserProfile);
        }

        function fillDropDowns() {
            var promiseArray = [];

            vm.dropDowns = {};

            promiseArray.push(authentication.getArmyComponents().then(function (response) {
                vm.dropDowns.components = response.values;
            }));

            promiseArray.push(authentication.getBranchOfServices().then(function (response) {
                vm.dropDowns.branches = response.values;
            }));

            promiseArray.push(authentication.getPayGrades().then(function (response) {
                vm.dropDowns.ranks = response.values;
            }));

            promiseArray.push(authentication.getCivilianPayGrades().then(function (response) {
                vm.dropDowns.civilianRanks = response.values;
            }));

            promiseArray.push(authentication.getDispositions().then(function (response) {
                response.values.forEach(function (disposition) {
                    vm.dispositions[disposition] = {
                        name: disposition,
                        selected: false,
                        disabled: false
                    };
                });
            }));

            promiseArray.push(authentication.getCommunities({
            }).then(function (response) {
                vm.dropDowns.communities = response.communityAffiliations;
            }));

            return $q.all(promiseArray).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
            });
        }

        function getUserProfile() {
            vm.isLoading = true;

            var params = null;

            var getUserProfilePromiseArray = [];
            var commCheckPromiseArray = [];

            getUserProfilePromiseArray.push(authentication.getUserProfile(params)
                .then(function (response) {
                    // If editing own profile and a part is incomplete (not checking admin profile)
                    if (!authentication.isAosProfileValid(response.aosUser)) {
                        vm.noProfile = true;
                        vm.formSuccess = '';
                        vm.formError = "You must enter data in all required fields in order to update your AFWP profile. Note that some or all of this data is used by other AFWP systems.";

                        vm.initialDate = moment().format('MM/DD/YYYY');
                    }

                    vm.email = response.masterUserEmail || response.aosUser.email;

                    var aosProfile = response.aosUser;

                    vm.fullName = aosProfile.firstName + " " + aosProfile.lastName;

                    vm.aosProfile = {};
                    vm.aosProfile.firstName = aosProfile.firstName || '';
                    vm.aosProfile.middleInitial = aosProfile.middleInitial ? aosProfile.middleInitial : '';
                    vm.aosProfile.lastName = aosProfile.lastName || '';
                    vm.aosProfile.dateOfBirth = aosProfile.dateOfBirth ? moment(aosProfile.dateOfBirth, 'YYYY-MM-DD').toDate() : undefined;


                    if (aosProfile.communityAffiliationId) {
                        commCheckPromiseArray.push(authentication.isCommunityArchived(aosProfile.communityAffiliationId)
                            .then(function (isArchived) {
                                if (isArchived) {
                                    vm.formSuccess = '';
                                    vm.formError = "The Military Community you were a part of has been inactivated. Please select a new one.";
                                }
                            })
                        );

                        oldCommunity = vm.aosProfile.militaryCommunity = vm.dropDowns.communities.filter(function (comm) {
                            return comm.communityAffiliationId === aosProfile.communityAffiliationId;
                        })[0];
                    }
                    else {
                        vm.aosProfile.militaryCommunity = oldCommunity = undefined;
                    }

                    vm.aosProfile.branch = aosProfile.branchOfService || '';
                    vm.aosProfile.component = aosProfile.armyComponent || '';

                    if (aosProfile.dispositions) {
                        aosProfile.dispositions.forEach(function (disposition) {
                            vm.dispositions[disposition].selected = true;
                            onChangeDisposition(vm.dispositions[disposition]);
                        });

                        if (vm.dispositions['Service Member'].selected) {
                            vm.aosProfile.rank = aosProfile.payGrade;
                        }
                        if (vm.dispositions['Family Member'].selected) {
                            vm.aosProfile.sponsorRank = aosProfile.sponsorPayGrade;
                        }
                        if (vm.dispositions['DoD Civilian'].selected) {
                            vm.aosProfile.civilianRank = aosProfile.civilianPayGrade;
                        }
                    }

                    if(aosProfile.aosRoles.length > 0){
                        aosProfile.aosRoles.forEach(function(aosRole){
                           if(aosRole === "AFWP Administrator"){
                               vm.roles.push(aosRole);
                           }
                        });
                    }
                })
                .catch(function (error) {
                    vm.formSuccess = '';
                    vm.formError = "Error: " + error;
                    vm.isLoading = false;
                }));

            commCheckPromiseArray.push(authentication.getCasInfoForUser(authentication.getEmail()).then(function (casInfo) {
                if(casInfo.user.admin){
                    vm.roles.push("CAS Administrator");
                }
            })
            .catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
                vm.isLoading = false;
            }));

            return $q.all(getUserProfilePromiseArray)
                .then(function () {
                    return $q.all(commCheckPromiseArray)
                        .then(function () {
                            vm.isLoading = false;
                        });

                });
        }

        function onSubmit() {
            setUserProfile();
        }

        function setUserProfile() {
            var aosUser = {
                firstName: vm.aosProfile.firstName,
                middleInitial: vm.aosProfile.middleInitial,
                lastName: vm.aosProfile.lastName,
                dateOfBirth: moment(vm.aosProfile.dateOfBirth).format('YYYY-MM-DD'),
                communityAffiliationId: vm.aosProfile.militaryCommunity.communityAffiliationId,
                branchOfService: vm.aosProfile.branch,
                armyComponent: vm.aosProfile.component,
                dispositions: []
            };

            angular.forEach(vm.dispositions, function (disposition) {
                if (disposition.selected) aosUser.dispositions.push(disposition.name);
            });

            if (vm.dispositions['Service Member'].selected) {
                aosUser.payGrade = vm.aosProfile.rank;
            }
            if (vm.dispositions['Family Member'].selected) {
                aosUser.sponsorPayGrade = vm.aosProfile.sponsorRank;
            }
            if (vm.dispositions['DoD Civilian'].selected) {
                aosUser.civilianPayGrade = vm.aosProfile.civilianRank;
            }

            var promise = $q.resolve();
            promise.then(function () {
                return authentication.setUserProfile(aosUser);
            }).then(function () {
                oldCommunity = vm.aosProfile.militaryCommunity;
                vm.formError = '';
                vm.formSuccess = 'Profile updated successfully!';
                // Alert header and side nav to update for any possible changes if not admin editing
                if (!vm.masterUserId)
                    $scope.$emit('profile:update');
                // Just update profile page header if admin editing
                else
                    vm.fullName = aosUser.firstName + " " + aosUser.lastName;
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = "Error: " + error;
            }).finally(function () {
                $anchorScroll('anchor-top');
            });
        }

        function onCancel() {
            $state.go('accountManagement.dashboard', null, { reload: true });
        }

        function onChangeDisposition(disposition) {
            vm.dispositionsSelected += disposition.selected ? 1 : -1;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('VerifyController', VerifyController);

    VerifyController.$inject = ['authentication', '$state', 'isVerifying', '$modalInstance', 'config'];

    function VerifyController(authentication, $state, isVerifying, $modalInstance, config) {
        var vm = this;

        vm.isVerifying = isVerifying;

        vm.modalTitle = isVerifying ? "Verify Email" : "Request Verification Email";

        vm.onSubmit = onSubmit;

        function onSubmit() {
            if(isVerifying) {
                authentication.verifyAccount(
                    vm.email, vm.token
                ).then($modalInstance.close).catch(function (error) {
                    vm.formError = error;
                });
            }
            else {
                authentication.sendVerificationEmail(vm.email).then($modalInstance.close).catch(function (error) {
                    vm.formError = error;
                });
            }
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResetTokenController', ResetTokenController);

    ResetTokenController.$inject = ['authentication', '$state', '$modalInstance', 'config'];

    function ResetTokenController(authentication, $state, $modalInstance, config) {
        var vm = this;
        vm.modalTitle = "Reset Token";
        vm.onSubmit = onSubmit;

        vm.casServer = null;
        vm.resetUrl = null;
        vm.accountManagementUrl = window.location.origin;

        activate();

        function activate() {
            config.get().then(function(configData){
                vm.casServer = configData.casServer;
            });
        }

        function onSubmit() {
            // Create the URL
            vm.resetUrl = vm.casServer + "login?service=" + vm.accountManagementUrl + "&onetimeTicket=" + vm.token.trim();

            // Redirect the user to the URL
            window.location.assign(vm.resetUrl);
        }
    }
})();
// This file is regenerated each time the app is run using the version value in package.json.var APP_VERSION = '1.6.0';



(function(){'use strict';angular.module('templates').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/accountManagement.view.html','<header role="banner" class="site-header"> <icon id="hamburger-button" name="fa-bars" class="header-icon-menu clickable register-header" ng-click="vm.showMenu = !vm.showMenu;"></icon> <div ng-show="vm.showMenu" class="main-menu" style="padding: 0; background: transparent; border: none;"> <ul id="hamburger-dropdown"> <li style="border: 0 solid black;" ng-repeat="website in vm.websiteFamilyList"> <a class="main-menu-links" href="{{website.url}}" target="_blank"> <icon name="fa-circle" class="{{website.color}}"></icon> {{website.name}} </a> </li> </ul> </div> <div id="header-logo-title-section" class="title" ng-click="vm.goHome()"> <img class="site-icon" src="../../assets/img/US-Army-logo-small.png" alt="AFWP Icon"> <h1 class="show-for-medium">AFWP Account Management</h1> <h1 class="hide-for-medium">AFWP</h1> </div> <div class="header-right float-right"> <div ng-if="vm.isLoggedIn"> <menu-dropdown id="header-user-section" is-open="vm.isDropdownOpen"> <menu-dropdown-toggle class="user-button"> <icon name="fa-user-circle-o" alt="User Icon"></icon> <div class="profile-badge"> <span class="header-right-text">{{vm.firstName}}</span> <span ng-if="!!vm.lastLoginDate" class="last-login">Last Login: {{vm.lastLoginDate}} </span> </div> <icon name="fa-caret-down" alt="Select this caret to view profile, change account settings, or log out"></icon> </menu-dropdown-toggle> <menu-dropdown-pane> <ul class="menu vertical"> <li id="user-dropdown-profile" ng-click="vm.onClickViewProfile()">View Profile</li> <li class="separator"></li> <li id="user-dropdown-logout" ng-click="vm.onClickLogOut()">Log Out</li> </ul> </menu-dropdown-pane> </menu-dropdown> </div> <div id="header-register" ng-if="!vm.isLoggedIn" class="clickable manage-users-button float-left" ng-click="vm.register()"> <span class="header-right-text no-hover">Register</span> </div> <div id="header-login" ng-if="!vm.isLoggedIn" class="clickable login-button" ng-click="vm.logIn()"> <icon name="fa-user-circle" class="no-hover" alt="User Icon"></icon> <span class="header-right-text no-hover">Log In</span> </div> </div> </header> <button class="nav-button button" ng-class="{\'is-shown\': vm.navClosed}" ng-click="vm.toggleNav()" aria-label="Side navigation bar toggle"> <icon name="fa-caret-right" class="icon-big clickable" alt="Select this icon to toggle the side navigation bar"></icon> </button> <nav role="navigation" id="am-sidebar-nav" class="nav-bar" data-sticky-container ng-class="{\'is-closed\': vm.navClosed}"> <ul class="vertical menu"> <li id="nav-dashboard" ui-sref-active="active" class="nav-entry"> <a ui-sref="accountManagement.dashboard"> Dashboard </a> </li> <li id="nav-profile" ng-if="vm.isLoggedIn" ui-sref-active="active" class="nav-entry"> <a ui-sref="accountManagement.profile"> Profile </a> </li> <li id="nav-administrator-header" ng-if="vm.isLoggedIn && (vm.isAdmin || vm.isAfwpAdmin)"> <h4 class="nav-title nav-static-title"> Administrator </h4> </li> <li id="nav-manage-users" ng-if="vm.isLoggedIn && (vm.isAdmin || vm.isAfwpAdmin)" ui-sref-active="active" class="nav-entry"> <a ui-sref="accountManagement.manageUsers"> Manage Users </a> </li> <li id="nav-hierarchy" ng-if="vm.isLoggedIn && vm.isAfwpAdmin" ui-sref-active="active" class="nav-entry"> <a ui-sref="accountManagement.hierarchy"> Hierarchy </a> </li> <li id="nav-loginStats" ng-if="vm.isLoggedIn && vm.isAfwpAdmin" ui-sref-active="active" class="nav-entry"> <a ui-sref="accountManagement.loginStats"> Login Stats </a> </li> <li id="nav-close" class="nav-entry hide-for-large"> <a ng-click="vm.toggleNav()">Close Side Nav</a> </li> </ul> </nav> <main role="main" class="main-view" ng-class="{\'nav-closed\': vm.navClosed}"> <div ui-view style="position:relative;"></div> </main> <footer role="contentinfo" class="site-footer expanded row"> <span id="contact-helpdesk"> <a id="contact-helpdesk-link" target="_blank" ng-href="{{vm.contactHelpDeskUrl}}">Contact Help Desk</a> </span> <span class="link-divider">|</span> <span> <img class="footer-logos" src="../../assets/img/AMC-IMCOM-MWR-ACS-Color.png"> </span> <span ng-if="vm.footerMessage.length"> <span class="link-divider">|</span> <span id="footer-info-section"> {{vm.footerMessage}} </span> </span> <span class="link-divider">|</span> <span id="about-section"> <a ng-click="vm.openAboutModal()">About</a> </span> </footer> ');
$templateCache.put('app/components/about/about.modal.view.html','<modal close="aboutModal.stayOpen ? null : $dismiss" modal-title="About Account Management"> <modal-body> <loading-icon show="aboutModal.isLoading"></loading-icon> <div class="row" ng-hide="aboutModal.isLoading"> <div class="small-12 columns"> <h4 id="acronym-definition">Account Management</h4> <p id="explanation">The below table lists version and status information about the system:</p> </div> <div class="small-12 columns"> <table class="information-table table"> <thead> <tr> <th>Component</th> <th>Version</th> <th>Additional Info</th> </tr> </thead> <tbody> <tr ng-show="aboutModal.amUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="am-ui-title">AM User Interface</td> <td id="am-ui-version">{{aboutModal.amUi.numericalVersion}}</td> <td id="am-ui-info"> Deployed: <span id="am-ui-date">{{aboutModal.amUi.date}}</span> <span ng-if="aboutModal.amUi.url"> <br> Hash: (<a id="am-ui-commit-url" target="_blank" ng-href="{{aboutModal.amUi.url}}">{{aboutModal.amUi.version}}</a><span id="am-ui-commit" ng-if="!aboutModal.amUi.url">{{aboutModal.amUi.version}}</span>) </span> </td> </tr> <tr ng-show="aboutModal.amUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="core-api-title">Core API</td> <td id="core-api-version">{{aboutModal.coreApi.version}}</td> <td id="core-api-info">{{aboutModal.coreApi.online ? "Online": "Offline"}}</td> </tr> <tr ng-show="aboutModal.amUi.display" ng-class-even="\'even\'" ng-class-odd="\'odd\'"> <td id="cas-title">Single Sign-On (CAS/CUA)</td> <td id="cas-version">{{aboutModal.cas.version}}</td> <td id="cas-info">{{aboutModal.cas.online ? "Online": "Offline"}}</td> </tr> <tr ng-hide="aboutModal.amUi.display"> <td id="no-data-row" colspan="3"> System version information unavailable </td> </tr> </tbody> </table> </div> </div> </modal-body> <modal-footer> <button type="submit" class="dflt button pull-right" ng-click="$close()" ng-hide="aboutModal.stayOpen">OK</button> </modal-footer> </modal> ');
$templateCache.put('app/components/dashboard/dashboard.view.html','<h1 id="dashboard-title">Dashboard</h1> <learn-about-this-page learn-title="About Dashboard Page" text-body="Welcome to the AFWP Account Management (AM) page. Here, you can update your AFWP profile, edit your email and password used to log in, and connect a Common Access Card (CAC) to your account. AFWP Administrators have the additional option to manage users and maintain the hierarchy.\nOn this Dashboard page you are given immediate services for updating log-in information and CAC connectivity. Use the pencil icons to edit your Email or Password. Changes made to the credentials here affect your Single Sign-On (SSO).\nConnect your CAC by first ensuring your CAC is inserted before opening your browser. Then, when logging in, select the relevant certificate and enter your PIN. On the SSO page, enter your email and password (because your CAC is not yet connected). Finally, on this Dashboard page click \'Connect my CAC\'."></learn-about-this-page> <div class="main-content"> <form name="form" class="form" data-ng-submit="vm.onSubmit(); form.$setPristine()"> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div ng-hide="vm.isLoading"> <table class="information-table table"> <thead> <tr> <th ng-hide="vm.isLoggedIn">You Must Login First</th> <th ng-hide="!vm.isLoggedIn">Log-In Information</th> </tr> </thead> </table> <div ng-show="!vm.isLoggedIn"> <div class="row"> <div class="small-12 columns"> <p> You must <a class="body-link-text" ui-sref="accountManagement.logIn">log in</a> to access this application. </p> </div> <div class="small-12 columns"> <p> Not a member? <a class="body-link-text" ui-sref="accountManagement.register">Register</a> a new account. </p> </div> <div class="small-12 columns"> <p> <a class="body-link-text" ng-click="vm.onClickVerifyAccount()">Verify</a> your new account with a token or <a class="body-link-text" ng-click="vm.onClickRequestVerificationEmail()">Request Verification Email</a>. </p> </div> <div class="small-12 columns"> <p> <a class="body-link-text" ng-click="vm.onClickEnterResetToken()">Click here</a> to enter your Reset Password Token. </p> </div> <div class="small-12 columns"> <div id="browser-box"> <p id="home-page-browser-info"> Supported browsers for AFWP Applications are Edge, Chrome, and Firefox. You may experience functionality and appearance differences when using the application depending on your browser version. </p> </div> </div> </div> </div> <div ng-show="vm.isLoggedIn"> <div class="row"> <div class="small-12 columns"> <label class="middle">Changing these settings will update your account access for all AFWP applications using the AFWP Single Sign-On (SSO) feature.</label> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right middle"> Email </label> </div> <div class="small-3 columns"> <label class="middle float-left">{{vm.email}}</label> </div> <div class="small-3 small-offset-3 columns center-horizontal"> <icon id="email-icon" name="fa-pencil" class="icon-lg clickable hyperlink-button-div" ng-click="vm.onClickEditEmail()"></icon> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right middle"> Password </label> </div> <div class="small-3 columns"> <label class="middle float-left">********</label> </div> <div class="small-3 small-offset-3 columns center-horizontal"> <icon id="password-icon" name="fa-pencil" class="icon-lg clickable hyperlink-button-div" ng-click="vm.onClickEditPassword()"></icon> </div> </div> <table class="information-table table"> <thead> <tr> <th>Common Access Card (CAC) Connection</th> </tr> </thead> </table> <div class="row" ng-show="!(vm.cacRegistered && vm.cacInUse)"> <div class="small-9 columns"> <label class="middle" ng-show="!vm.cacRegistered">Connect your CAC to streamline access to the AFWP system. You must have opened your browser with your CAC inserted, selected the proper certificate, and entered your PIN before clicking this button. Close and reopen your browser completely (all windows and tabs) to re-enable these prompts on login if needed. Clicking the button multiple times will overwrite any previously connected CAC with the CAC currently inserted.</label> <label class="middle" ng-show="vm.cacRegistered && !vm.cacInUse">You have logged in with your username and password while having a CAC registered to your account. If you need to replace your CAC, you must have opened your browser with your CAC inserted, selected the proper certificate, and entered your PIN before clicking this button. Close and reopen your browser completely (all windows and tabs) to re-enable these prompts on login if needed. Clicking the button multiple times will overwrite any previously connected CAC with the CAC currently inserted.</label> </div> <div class="small-3 columns center-horizontal"> <button id="cac-button" type="button" class="dflt button" ng-click="vm.onClickConnectCAC()" ng-disabled="vm.isLoading"> {{!vm.cacRegistered ? "Connect my CAC" : "Replace my CAC"}} </button> </div> </div> <div class="row" ng-show="vm.cacRegistered && vm.cacInUse"> <div class="small-12 columns"> <label class="middle">Your CAC is successfully connected to your account. <icon name="fa-check" class="green" aria-hidden="true"></icon></label> </div> </div> <div> <div class="small-9 columns" ng-show="vm.cacRegistered"> <label>Remove the CAC you currently have connected to your account.</label> </div> <div class="small-3 columns center-horizontal"> <button id="cac-button" type="button" class="dflt button" ng-show="vm.cacRegistered" ng-click="vm.onClickRemoveCAC()" ng-disabled="vm.isLoading"> Remove my CAC </button> </div> </div> </div> </div> <loading-icon show="vm.isLoading" push-down="true"></loading-icon> </form> </div> ');
$templateCache.put('app/components/dashboard/editEmail.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="Edit Email"> <modal-body> <div role="alert" class="callout warning ng-binding">Warning: Once you change your email address, you will be logged out of AFWP SSO and this application in order to finalize the change. </div> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <label> <span class="bold">Current Email</span> <label>{{vm.email}}</label> </label> <label> <span class="bold">New Email</span><span class="required text">*</span> <input type="email" ng-maxlength="100" ng-model="vm.newEmail" autcomplete="email" required> </label> <label> <span class="bold">Re-enter Email</span><span class="required text">*</span> <input type="email" ng-maxlength="100" ng-model="vm.reenterNewEmail" autocomplete="email" required> </label> <p class="help-text pull-left"><span class="required text">*</span>Indicates a required field.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.newEmail !== vm.reenterNewEmail">Save </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/dashboard/editPassword.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="vm.isDismissible ? $dismiss : null" modal-title="Edit Password"> <modal-body> <div role="alert" class="callout warning ng-binding">Warning: Once you change your password, you will be logged out of AFWP SSO and this application in order to finalize the change. </div> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <label> <span class="bold">New Password</span><span class="required text">*</span> <input id="input-new-password" name="password" type="password" placeholder="Enter password" ng-model="vm.newPassword" pattern="{{vm.passwordRequirements.regex}}" tooltip="{{vm.passwordRequirements.description}}" tooltip-placement="top" tooltip-trigger="focus" required autocomplete="new-password" password-validator> </label> <div class="columns" ng-show="form.$submitted || form.password.$touched"> <span ng-show="!form.password.$valid">Requirements:</span> <ul> <li ng-show="form.password.$error.passwordLength">At least 15 characters long</li> <li ng-show="form.password.$error.passwordUpper">At least 2 uppercase letters</li> <li ng-show="form.password.$error.passwordLower">At least 2 lowercase letters</li> <li ng-show="form.password.$error.passwordNum">At least 2 numbers</li> <li ng-show="form.password.$error.passwordSpecial">At least 2 special characters</li> <li ng-show="form.password.$error.passwordSpace">No spaces</li> </ul> </div> <label> <span class="bold">Re-enter Password</span><span class="required text">*</span> <input id="input-re-enter-password" name="reenterPassword" type="password" placeholder="Re-enter password" ng-model="vm.reenterNewPassword" tooltip="Must match above password" tooltip-placement="top" tooltip-trigger="focus" required autocomplete="new-password"> </label> <p class="help-text pull-left"><span class="required text">*</span>Indicates a required field.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.newPassword !== vm.reenterNewPassword"> Save </button> <button type="button" class="dflt button" ng-click="$dismiss()" ng-if="vm.isDismissible">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/hierarchy/addOrEditChildModal.template.html','<modal close="$dismiss" modal-title="{{vm.modalTitle}}"> <modal-body> <div ng-show="vm.formError" class="callout alert">{{vm.formError}}</div> <div class="row"> <div class="small-12 columns"> <p>{{vm.modalHelp}}</p> </div> </div> <div class="row"> <div class="small-12 columns"> <label for="community-name" class="bold text-left middle"> Name </label> </div> </div> <div class="row"> <div class="small-12 columns"> <input id="community-name" type="text" ng-model="vm.communityName" ng-change="vm.checkCanSave()"> </div> </div> <div class="row"> <div class="columns small-5 center-horizontal"> <input id="region-check" type="checkbox" class="text-left iefixcheckboxbackground" ng-disabled="vm.hasChildren" ng-model="vm.isRegion" ng-click="vm.checkCanSave()"> <label for="region-check" class="bold smallcheckbox">Region</label> </div> <div class="columns small-5 center-horizontal"> <input id="inactive-check" type="checkbox" class="iefixcheckboxbackground" ng-disabled="vm.disableInactive" ng-model="vm.isArchived" ng-click="vm.enableSave=vm.communityName.length > 0"> <label for="inactive-check" class="bold smallcheckbox" ng-class="{\'has-tip cursor-help\': vm.disableInactive}" tooltip="{{vm.disableInactive ? (vm.parentId === null ? \'You cannot make the top community inactive\' : \'Parent is inactive\') : \'\'}}" tooltip-popup-delay="200">Inactive</label> </div> </div> <div class="row"> <div class="small-12 columns"> <label for="community-name" class="bold text-left middle"> Parent Community </label> </div> </div> <div class="row"> <div ng-if="vm.showHierarchy" class="small-12 columns"> <div class="input-group"> <div class="input-group-label icon-label" ng-show="vm.showHierarchy"> <icon name="fa-search" alt="Search AFWP Communities"></icon> </div> <input id="search" type="text" class="input-group-field" aria-label="Search AFWP communities" ng-model="vm.parentName" ng-change="vm.checkCanSave()" ng-disabled="!vm.showHierarchy"> </div> </div> <div ng-if="!vm.showHierarchy" class="small-12 columns"> <div class="input-group"> <label class="input-group-field">{{vm.parentName}}</label> </div> </div> </div> <div class="row"> <div class="small-3 columns"> <a ng-click="vm.showHierarchy = true;vm.parentName=\'\';" ng-hide="vm.showHierarchy">Change Parent</a> <a ng-click="vm.onCommunityCancelled();" ng-show="vm.showHierarchy && vm.parentId !== null">Cancel</a> </div> </div> <div class="row"> <communities-drop-down ng-show="vm.showHierarchy" on-community-click="vm.onCommunityClicked" refresh-flag="vm.refreshCommunityList" search-text="vm.parentName" show-leafs="false" show-inactive="true" disabled-community-id="vm.communityId" start-collapsed="true" style="height: 200px;"></communities-drop-down> </div> </modal-body> <modal-footer> <div class="float-right"> <button data-ng-disabled="!vm.enableSave" class="dflt button" type="button" ng-click="vm.onSubmit()">Save</button> <button class="dflt button" type="button" ng-click="vm.onCancel()">Cancel</button> </div> </modal-footer> </modal>');
$templateCache.put('app/components/hierarchy/confirmCommunityInactive.template.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="{{vm.title}}"> <modal-body> <p>Are you sure you want to inactivate <strong>{{vm.name}}</strong>?</p> <ul> <li>Inactivating a community within the AFWP hierarchy will inactivate the community associated with the user\u2019s profile. Going forward, users will not be able to select the inactive community as their chosen military community while it is in the inactive state.</li> <li>This inactivation has NO impact on system specific community listings such as the list within IMS to which issues can be submitted or the list in ACS Staff to which clients can be assigned.</li> </ul> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onAccept()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/hierarchy/hierarchy.view.html','<h1>AFWP Community Hierarchy</h1> <div role="alert" class="callout warning ng-binding">Changes to the hierarchy will impact the following systems: VMIS, IMS.</div> <div class="row"> <div class="small-9 columns"> <div class="input-group"> <div class="input-group-label icon-label"> <icon name="fa-search" class="icon-lg" alt="Search AFWP Communities"></icon> </div> <input id="search-communities" type="text" class="input-group-field" ng-model="vm.communitySearchText" placeholder="Search for community" ng-change="vm.search(vm.searchText)" ng-model-options="{debounce: 750}" aria-label="Search communities"> </div> </div> <div class="small-3 columns"> <button type="button" class="dflt button float-right" ng-click="vm.onAddChildClicked()"> Add New Community </button> </div> </div> <div style="height: calc(100% - 200px);"> <div class="row" style="height: 100%;"> <div class="small-12 columns" style="height: inherit"> <communities-drop-down on-community-click="vm.onCommunityClicked" refresh-flag="vm.refreshCommunityList" search-text="vm.communitySearchText" show-leafs="true" show-inactive="true" start-collapsed="true" style="height: calc(100% - 30px);"></communities-drop-down> </div> </div> </div> ');
$templateCache.put('app/components/idle/idle.view.html','<form ng-submit="$close()" name="form"> <modal modal-title="Stay Logged In?"> <modal-body> You will be logged out of Account Management in {{vm.countdown}} second(s) due to inactivity. </modal-body> <modal-footer> <div class="float-right"> <div> <button type="button" class="dflt button" ng-click="$close()">Stay Logged In</button> </div> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/loggedOut/loggedOut.view.html','<div id="logged-out-page"> <h1 id="logout-text">Logged Out</h1> <alert id="logout-alert" type="\'warning\'" ng-show="vm.formError">{{vm.formError}}</alert> <p>You\'ve been logged out of Single Sign On (SSO) for Account Management.</p> <p> You may still be logged in to other AFWP systems. Close your browser to completely log out from them. (This is required if you just completed connecting your CAC.) </p> <p>Click <a id="log-back-in-text" ui-sref="accountManagement.logIn">here</a> to log back in.</p> </div> ');
$templateCache.put('app/components/loginStats/loginStats.view.html','<h1 id="login-stats-title">Login Stats</h1> <p>Total Users who have logged into each system broken down by Community Groups given a selected date range</p> <learn-about-this-page learn-title="About Login Stats" text-body="This page contains Login Statistics by groups of communities given a selected date range"></learn-about-this-page> <div id="manage-users-content" class="main-content"> <form ng-hide="vm.isLoading || !vm.isAfwpAdmin" name="form" class="form"> <div class="expanded row"> <div class="small-3 columns"> <label for="from">From <span class="input-group"> <input id="from" type="text" class="input-group-field" ng-model="vm.startDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" vmis-datepicker target="start-date" format="M/D/YYYY" end-date="vm.endDate || vm.currentDate" required> <span class="input-group-button"> <button id="start-date" type="button" class="dflt button icon-button" aria-label="Starting date" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar icon to choose the starting date"></icon> </button> </span> </span> </label> </div> <div class="small-3 columns"> <label for="to">To <span class="input-group"> <input id="to" type="text" class="input-group-field" ng-model="vm.endDate" ng-model-options="{updateOn: \'default programmatic\', debounce: {default: 500, programmatic: 0}}" placeholder="MM/DD/YYYY" vmis-datepicker target="end-date" format="M/D/YYYY" start-date="vm.startDate" end-date required> <span class="input-group-button"> <button id="end-date" type="button" class="dflt button icon-button" aria-label="Ending date" data-ng-disabled="vm.isLoading"> <icon name="fa-calendar" class="icon-big" alt="Select this calendar icon to choose the ending date"></icon> </button> </span> </span> </label> </div> <div class="small-6 columns button-row"> <label> <span class="input-group"> <button type="submit" class="dflt button" ng-disabled="vm.isLoading" ng-click="vm.onClickSearch(vm.startDate,vm.endDate)" disabled="disabled">Search</button> </span> </label> </div> </div> <div class="row" ng-show="vm.isDataLoaded" ng-repeat="item in vm.loginCount.services"> <h3>{{vm.decodeUrl(item.service)}}</h3> <table class="information-table table"> <thead> <tr> <th>IMCOM_ACTIVE</th> <th>NON_IMCOM</th> <th>GUARD</th> <th>BRAC</th> <th>OTHER</th> <th>RESERVE</th> <th>TOTAL</th> </tr> </thead> <tr> <td>{{item[\'IMCOM Active\']}}</td> <td>{{item[\'Non IMCOM\']}}</td> <td>{{item[\'Guard\']}}</td> <td>{{item[\'BRAC\']}}</td> <td>{{item[\'Other\']}}</td> <td>{{item[\'Reserve\']}}</td> <td>{{item[\'IMCOM Active\']+item[\'Non IMCOM\']+item[\'Guard\']+item[\'BRAC\']+item[\'Other\']+item[\'Reserve\']}}</td> </tr> </table> </div> </form> <div ng-show="!vm.isAfwpAdmin"> <h2>You do not have permissions to view this page</h2> </div> </div> <loading-icon show="vm.isLoading"></loading-icon>');
$templateCache.put('app/components/manageUsers/confirmPasswordReset.view.html','<form ng-submit="$close()" name="form"> <modal close="$dismiss" modal-title="Reset Password"> <modal-body> <p>Are you sure you want to reset <strong>{{vm.email}}</strong> password?</p> <label> <span class="bold">This can not be undone. </span> </label> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="vm.onAccept()">Yes</button> <button type="button" class="dflt button" ng-click="$dismiss()">No</button> </div> </modal-footer> </modal> </form> ');
$templateCache.put('app/components/manageUsers/manageUsers.view.html','<h1 id="manage-users-title">Manage Users</h1> <learn-about-this-page learn-title="About Manage Users Page" text-body="This page contains the following data and features:\r\n    \u2022 ID - Unique identifier assigned to each AFWP Account.\r\n    \u2022 Last Active - Provides the date and time of the user\'s successful last logged-in session on any AFWP system.\r\n    \u2022 CAS Admin - Denotes the AFWP Account is a CAS Administrator.\r\n    \u2022 CAC Registered - Denotes whether the account has an associated Common Access Card (CAC)\r\n    \u2022 AFWP Admin - Denotes the AFWP Account is a AFWP Administrator\r\n    \u2022 Email Verified - Denotes the AFWP Account has successfully completed all additional account verification steps.\r\n    &nbsp&nbsp&nbsp&nbsp \u2022 Note: These additional steps are not required for all AFWP systems.\r\n    \u2022 Disable Date - Date when the AFWP Account was disabled.\r\n    \u2022 Last Failed Login - Date when the AFWP Account had a failed login attempt.\r\n    \u2022 Number of consecutive failed password attempts.\r\n    &nbsp&nbsp&nbsp&nbsp \u2022 If this value is greater than 2, the account is locked for 60 minutes.\r\n    \u2022 Enable - Restore the user\u2019s ability to log in with the selected AFWP Account.\r\n    &nbsp&nbsp&nbsp&nbsp \u2022 Only applies to disabled accounts who have been disabled due to admin, # of failed password attempts, or inactivity.\r\n    \u2022 Disable - Revoke the user\u2019s ability to log in with the selected AFWP Account. \r\n    &nbsp&nbsp&nbsp&nbsp \u2022 Only applies to accounts that are not disabled by an admin.\r\n    &nbsp&nbsp&nbsp&nbsp \u2022 If account is disabled by failed password attempts or inactivity, they can still be disabled by an admin."></learn-about-this-page> <div id="manage-users-content" class="main-content"> <form ng-hide="vm.isLoading" name="form" class="form" data-ng-submit="vm.onSubmit(); form.$setPristine()"> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div ng-if="!(vm.isAdmin || vm.isAfwpAdmin)"> <h1>You are not authorized to use this page</h1> </div> <div ng-if="vm.isAdmin || vm.isAfwpAdmin"> <div class="row"> <div class="small-2 columns"> <label class="bold text-right middle" for="email"> User Email: </label> </div> <div class="small-8 columns"> <input id="email" ng-maxlength="100" required type="text" ng-model="vm.searchString" ng-change="vm.onSearchAllUsers()" ng-disabled="vm.isWaiting"> </div> </div> <div ng-if="vm.isAdmin" class="row"> <table class="information-table table"> <thead> <tr> <th class="tiny">Select</th> <th>Email</th> </tr> </thead> <tbody> <tr ng-repeat="user in vm.searchResults"> <td> <input type="checkbox" class="checkbox" aria-label="{{\'Select entry\' + ($index + 1) }}" id="{{ \'checkbox-\' + ($index + 1) }}" ng-model="user.isChecked" ng-click="vm.onCheckActivity($index,vm.searchResults)"> </td> <td>{{user.email}}</td> </tr> </tbody> </table> </div> <div class="row"> <table class="information-table table"> <thead> <tr> <th ng-if="vm.isAdmin">ID</th> <th ng-if="vm.isAdmin">Email</th> <th ng-if="vm.isAdmin">Created Date</th> <th ng-if="vm.isAdmin">Last Active</th> <th ng-if="vm.isAdmin">Last Login Time</th> <th ng-if="vm.isAdmin">Last Login Method</th> <th ng-if="vm.isAdmin">CAC Registered</th> <th ng-if="vm.isAdmin">CAS Admin</th> <th ng-if="vm.isAfwpAdmin">AFWP Admin</th> <th ng-if="vm.isAdmin">Email Verified</th> <th ng-if="vm.isAdmin">Disable Date</th> <th ng-if="vm.isAdmin">Last Failed Login</th> <th ng-if="vm.isAdmin"># of Failed Password Attempts</th> </tr> </thead> <tr ng-if="(!vm.isEmpty && (!vm.formError || vm.displayInfoWhenErrored))"> <td ng-if="vm.isAdmin">{{vm.searchResult.casId}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.email}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.createdDate}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.lastActive}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.lastLoginTime}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.lastLoginMethod}}</td> <td ng-if="vm.isAdmin"> <icon name="fa-check" class="green" aria-hidden="true" aria-label="yes" ng-if="vm.searchResult.isCacRegistered && vm.searchResult.isCacRegistered !== null"></icon> <icon name="fa-times" class="red" aria-hidden="true" aria-label="no" ng-if="!vm.searchResult.isCacRegistered && vm.searchResult.isCacRegistered !== null"></icon> </td> <td ng-if="vm.isAdmin"> <icon name="fa-check" class="green" aria-hidden="true" aria-label="yes" ng-if="vm.searchResult.admin && vm.searchResult.admin !== null"></icon> <icon name="fa-times" class="red" aria-hidden="true" aria-label="no" ng-if="!vm.searchResult.admin && vm.searchResult.admin !== null"></icon> </td> <td ng-if="vm.isAfwpAdmin"> <icon name="fa-check" class="green" aria-hidden="true" aria-label="yes" ng-if="vm.isAccountAFWPAdmin && vm.isAccountAFWPAdmin !== null"></icon> <icon name="fa-times" class="red" aria-hidden="true" aria-label="no" ng-if="!vm.isAccountAFWPAdmin && vm.isAccountAFWPAdmin !== null"></icon> </td> <td ng-if="vm.isAdmin"> <icon name="fa-check" class="green" aria-hidden="true" aria-label="yes" ng-if="vm.searchResult.verified && vm.searchResult.verified !== null"></icon> <icon name="fa-times" class="red" aria-hidden="true" aria-label="no" ng-if="!vm.searchResult.verified && vm.searchResult.verified !== null"></icon> </td> <td ng-if="vm.isAdmin">{{vm.searchResult.disableDate}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.lastFailedLoginDate}}</td> <td ng-if="vm.isAdmin">{{vm.searchResult.failedPasswordCount}}</td> </tr> <tr ng-if="vm.isEmpty || (vm.formError && !vm.displayInfoWhenErrored)"> <td colspan="13"> No data to display </td> </tr> </table> </div> <div ng-if="!vm.isEmpty && vm.isAdmin" class="row"> The current status of this user is {{vm.currentStatus}}</div> <div class="row"> <div class="float-right"> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.onEnable()" ng-disabled="vm.isWaiting || vm.isEmpty || !vm.isAccountEnableable"> Enable </button> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.setAccountDisabled()" ng-disabled="vm.isWaiting || vm.isEmpty || vm.isAccountDisabled"> Disable </button> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.onPasswordReset()" ng-disabled="vm.isWaiting || vm.isEmpty"> Reset Password </button> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.onManageUserEmail()" ng-disabled="vm.isWaiting || vm.isEmpty"> {{ vm.manageUserEmailText }} </button> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.onClickRemoveCAC()" ng-disabled="vm.isWaiting || vm.isEmpty || !vm.searchResult.isCacRegistered"> Remove CAC </button> <button ng-if="vm.isAdmin" type="button" class="dflt button" ng-click="vm.onAdminEditing()" ng-disabled="vm.isWaiting || vm.isEmpty"> {{ vm.adminButtonText }} </button> <button ng-if="vm.isAfwpAdmin" type="button" class="dflt button" ng-click="vm.onAFWPAdminEditing()" ng-disabled="vm.isWaiting || vm.isEmpty || !vm.doesUserExistInAFWP"> {{ vm.afwpAdminButtonText }} </button> </div> </div> </div> </form> <loading-icon show="vm.isLoading"></loading-icon> </div>');
$templateCache.put('app/components/manageUsers/manageUsersEmail.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="Manage Email"> <modal-body> <div role="alert" class="callout warning ng-binding">Warning: once you change this email the user will no longer be able to log in with the old email. </div> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <label> <span class="bold">Current Email</span> <label>{{vm.email}}</label> </label> <label> <span class="bold">New Email</span><span class="required text">*</span> <input type="email" ng-maxlength="100" ng-model="vm.newEmail" autcomplete="email" ng-disabled="vm.isWaiting" required> </label> <label> <span class="bold">Re-enter Email</span><span class="required text">*</span> <input type="email" ng-maxlength="100" ng-model="vm.reenterNewEmail" autocomplete="email" ng-disabled="vm.isWaiting" required> </label> <p class="help-text pull-left"><span class="required text">*</span>Indicates a required field.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || vm.newEmail !== vm.reenterNewEmail || vm.isWaiting">Save </button> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isWaiting">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/manageUsers/showTempPassword.view.html','<modal close="$dismiss" modal-title="Temporary Password"> <modal-body> <div role="alert" class="callout warning ng-binding">Warning: This is a temporary password generated for the following user. Once you close this window you will not be allowed to view this password again. Please provide the user with this password so they can reset their account with their new password. </div> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <label> <span class="bold">Current Email</span> <label>{{vm.email}}</label> </label> <label> <span class="bold">Temporary Password </span> <label>{{vm.tempPassword}}</label> </label> </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$dismiss()" ng-disabled="vm.isWaiting">Close</button> </div> </modal-footer> </modal>');
$templateCache.put('app/components/profile/aosProfile.view.html','<table class="information-table table"> <thead> <tr> <th>Personal Information</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="first-name" class="bold text-right middle"> First Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="first-name" ng-maxlength="250" type="text" ng-model="vm.aosProfile.firstName" required autocomplete="given-name"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="middle-initial" class="bold text-right middle"> Middle Initial </label> </div> <div class="small-9 columns"> <input id="middle-initial" ng-maxlength="1" type="text" ng-model="vm.aosProfile.middleInitial"> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="last-name" class="bold text-right middle"> Last Name<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <input id="last-name" ng-maxlength="250" type="text" ng-model="vm.aosProfile.lastName" required autocomplete="family-name"> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right middle" for="birthDay"> Date of Birth<span class="required text">*</span> </label> </div> <div class="small-9 columns"> <span class="input-group"> <input type="text" id="birthDay" class="input-group-field" ng-model="vm.aosProfile.dateOfBirth" placeholder="MM/DD/YYYY" vmis-datepicker target="date-of-birth" format="M/D/YYYY" end-date required> <span class="input-group-button"> <button id="date-of-birth" type="button" class="dflt button icon-button" aria-label="Date of Birth"> <icon name="fa-calendar" class="icon-big"></icon> </button> </span> </span> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="military-community" class="bold text-right middle"> Military Community<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="military-community"> <ui-select required data-ng-model="vm.aosProfile.militaryCommunity"> <ui-select-match placeholder="Select a community or search..."> {{$select.selected.communityAffiliationName}} </ui-select-match> <ui-select-choices repeat="comm in vm.dropDowns.communities | propsFilter: {communityAffiliationName: $select.search}"> <span ng-bind-html="comm.communityAffiliationName | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <table class="information-table table"> <thead> <tr> <th>Demographic Information</th> </tr> </thead> </table> <div class="row"> <div class="small-3 columns"> <label for="branch" class="bold text-right middle"> Branch<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="branch"> <ui-select required data-ng-model="vm.aosProfile.branch"> <ui-select-match placeholder="Select a branch or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="branch in vm.dropDowns.branches | filter:$select.search"> <span ng-bind-html="branch | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label for="component" class="bold text-right middle"> Component<span class="required text">*</span> </label> </div> <div class="small-9 columns" id="component"> <ui-select required data-ng-model="vm.aosProfile.component"> <ui-select-match placeholder="Select a component or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="comp in vm.dropDowns.components | filter:$select.search"> <span ng-bind-html="comp | highlight: $select.search"></span> </ui-select-choices> </ui-select> </div> </div> <div class="row"> <div class="small-3 columns"> <label class="bold text-right"> Disposition(s)<span class="required text">*</span> </label> </div> <fieldset class="small-9 columns"> <div ng-repeat="(name, disposition) in vm.dispositions"> <input id="disposition-{{$index}}" type="checkbox" ng-model="disposition.selected" ng-model-options="{allowInvalid: true}" ng-change="vm.onChangeDisposition(disposition)" ng-required="!vm.dispositionsSelected"> <label for="disposition-{{$index}}" ng-class="{\'simple-tip\': (name === \'Non-DoD Civilian\')}" tooltip="{{(name === \'Non-DoD Civilian\') ? \'Non-DoD Civilian includes friends, significant others, and other designations not captured in the other Disposition options.\' : \'\'}}" tooltip-popup-delay="1000"> {{name}} </label> <div ng-switch="name" ng-show="disposition.selected" class="columns"> <label ng-switch-when="Service Member">Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.rank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.ranks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-switch-when="Family Member">Sponsor\'s Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.sponsorRank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.ranks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> <label ng-switch-when="DoD Civilian">Civilian Rank<span class="required text">*</span> <ui-select data-ng-required="disposition.selected" data-ng-model="vm.aosProfile.civilianRank"> <ui-select-match placeholder="Select a rank or search..."> {{$select.selected}} </ui-select-match> <ui-select-choices repeat="rank in vm.dropDowns.civilianRanks | filter:$select.search"> <span ng-bind-html="rank | highlight: $select.search"></span> </ui-select-choices> </ui-select> </label> </div> </div> </fieldset> </div> <table ng-if="vm.roles.length" class="information-table table"> <thead> <tr> <th>Administrator Information</th> </tr> </thead> </table> <div class="row" ng-if="vm.roles.length"> <div class="small-3 columns"> <label class="bold text-right"> Roles </label> </div> <div class="small-9 columns"> <ul class="admin-profile-communities-list"> <li ng-repeat="role in vm.roles">{{role}}</li> </ul> </div> </div>');
$templateCache.put('app/components/profile/profile.view.html','<h1 id="anchor-top">AFWP Profile</h1> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div role="alert" ng-show="vm.formSuccess" class="callout success">{{vm.formSuccess}}</div> <div ng-if="vm.isUatWebsite" role="alert" class="callout alert">This is a UAT site. Do not input real data.</div> <div ng-if="vm.isTrainingWebsite" role="alert" class="callout alert">This is a Training site. Do not input real data.</div> <label class="help-text" ng-hide="vm.isLoading"> <span class="required text">*</span>Indicates a required field. </label> <form name="form" class="form" data-ng-submit="vm.onSubmit(); form.$setPristine()"> <div ng-hide="vm.isLoading"> <div ng-include="\'app/components/profile/aosProfile.view.html\'"></div> <div class="pull-right"> <button type="submit" class="dflt button" data-ng-disabled="form.$invalid || form.$pristine || vm.isLoading"> Save </button> <button type="button" class="dflt button" ng-click="vm.onCancel()" data-ng-disabled="vm.isLoading"> Cancel </button> </div> </div> <loading-icon show="vm.isLoading" push-down="true"></loading-icon> </form> ');
$templateCache.put('app/components/register/register.view.html','<h1 id="registration-header">AFWP Registration</h1> <p id="already-paragraph">Already a member? Please <a id="log-in-link" ng-click="vm.logIn()">log in</a> instead.</p> <form name="form" data-ng-submit="vm.onSubmit(vm.email, vm.password)" novalidate class="container"> <div id="error" role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <div id="training-note" role="alert" ng-show="vm.trainingNote" class="callout primary">{{vm.trainingNote}}</div> <div class="row"> <div class="small-12 medium-8 large-4 small-centered columns"> <div class="row register-row"> <div class="columns"> <label>Email<span class="required text">*</span> <input id="input-email" name="email" type="email" placeholder="Enter Email" ng-maxlength="100" ng-model="vm.email" required autocomplete="username email" ng-disabled="vm.isLoading"> </label> </div> </div> <div class="row register-row"> <div class="columns"> <label>Confirm Email<span class="required text">*</span> <input id="input-confirm-email" name="confirmEmail" type="email" placeholder="Confirm Email" ng-maxlength="100" ng-model="vm.confirmEmail" confirm-data-error="vm.confirmEmail != vm.email" required autocomplete="username email" ng-disabled="vm.isLoading"> </label> </div> </div> <div class="row register-row"> <div class="columns"> <label>Password<span class="required text">*</span> <input id="input-password" name="password" type="password" placeholder="Enter Password" ng-model="vm.password" pattern="{{vm.passwordRequirements.regex}}" tooltip="{{vm.passwordRequirements.description}}" tooltip-placement="top" tooltip-trigger="focus" required autocomplete="new-password" password-validator ng-disabled="vm.isLoading"> </label> </div> <div class="columns" ng-show="form.$submitted || form.password.$touched"> <span>Requirements:</span> <ul> <li ng-class="form.password.$error.passwordLength ? \'invalid\' : \'valid\'">At least 15 characters long</li> <li ng-class="form.password.$error.passwordUpper ? \'invalid\' : \'valid\'">At least 2 uppercase letters</li> <li ng-class="form.password.$error.passwordLower ? \'invalid\' : \'valid\'">At least 2 lowercase letters</li> <li ng-class="form.password.$error.passwordNum ? \'invalid\' : \'valid\'">At least 2 numbers</li> <li ng-class="form.password.$error.passwordSpecial ? \'invalid\' : \'valid\'">At least 2 special characters</li> <li ng-class="form.password.$error.passwordSpace || form.password.length() == 0 ? \'invalid\' : \'valid\'">No spaces</li> </ul> </div> </div> <div class="row register-row"> <div class="columns"> <label>Confirm Password<span class="required text">*</span> <input id="input-confirm-password" name="confirmPassword" type="password" placeholder="Confirm password" ng-model="vm.confirmPassword" tooltip="Must match above password" tooltip-placement="top" tooltip-trigger="focus" confirm-data-error="vm.confirmPassword != vm.password" required autocomplete="new-password" ng-disabled="vm.isLoading"> </label> </div> </div> <div class="row"> <div class="columns"> <label class="help-text help-text-margin"> <span class="required text">*</span> Indicates a required field. </label> </div> </div> <div class="row"> <div class="columns"> <button id="register-button" type="submit" class="dflt button expanded" data-ng-disabled="form.$invalid || vm.isLoading"> Register </button> </div> </div> <div class="row"> <div class="columns"> <div class="text-center"> <p id="other-afwp-paragraph"> Registering through this page will grant you Single Sign-On (SSO) access to other AFWP applications. </p> </div> </div> </div> </div> </div> </form> ');
$templateCache.put('app/components/register/registrationLanding.view.html','<div id="registration-landing-page"> <h1 id="landing-header">Thanks for signing up!</h1> <p id="paragraph-1"> An email containing a verification token is being sent to the address you provided. Please use this on the <a id="dashboard-link" ui-sref="accountManagement.dashboard">Dashboard</a>. </p> <p id="paragraph-2"> You will not be able to access AFWP applications before verification. Please allow up to 30 minutes to receive the email, and be sure to check your spam folder. You may also request another verification email on the Dashboard. </p> <p id="paragraph-3"> Once logged in and verified, fill out your AFWP profile in order to access all applications. You may access them using the menu in the top-left. You may also register your Common Access Card (CAC) on the Dashboard. </p> </div> ');
$templateCache.put('app/components/resetToken/resetToken.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="{{vm.modalTitle}}"> <modal-body> <label> <span class="bold">Token</span><span class="required text">*</span> <input type="text" ng-maxlength="100" ng-model="vm.token" required> </label> <p class="help-text pull-left"><span class="required text">*</span>Indicates a required field.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid">Submit Reset Token </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/components/verify/verify.view.html','<form ng-submit="vm.onSubmit()" name="form"> <modal close="$dismiss" modal-title="{{vm.modalTitle}}"> <modal-body> <div role="alert" ng-show="vm.formError" class="callout warning">{{vm.formError}}</div> <label> <span class="bold">Email</span><span class="required text">*</span> <input type="email" ng-maxlength="100" ng-model="vm.email" required> </label> <div ng-if="vm.isVerifying" ng-show="vm.isVerifying"> <label> <span class="bold">Token</span><span class="required text">*</span> <input type="text" ng-maxlength="100" ng-model="vm.token" required> </label> </div> <p class="help-text pull-left"><span class="required text">*</span>Indicates a required field.</p> </modal-body> <modal-footer> <div class="pull-right"> <button type="submit" class="dflt button" ng-disabled="form.$invalid">{{vm.isVerifying?\'Verify Email\':\'Send Verification Email\'}} </button> <button type="button" class="dflt button" ng-click="$dismiss()">Cancel</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/common/directives/communitiesDropDown/communitiesDropDown.view.html','<div style="overflow-y: auto; height: inherit; background-color:white"> <loading-icon show="vm.isLoading" push-down="true"></loading-icon> <ul> <li ng-repeat="node in vm.communities" ng-include="\'app/common/directives/communitiesDropDown/communityList.view.html\'" ng-init="communityNode = vm.communities[0]" style="list-style: none;"></li> </ul> </div> ');
$templateCache.put('app/common/directives/communitiesDropDown/communityList.view.html','<button ng-click="vm.onClickExpandCollapse(communityNode)" aria-label="Expand or collapse node"> <icon name="{{vm.getIconNameForNode(communityNode)}}" class="icon-lg icon-records"></icon> </button> <button ng-click="vm.onClickCommunityNode(communityNode)" ng-if="vm.disabledCommunityId!==communityNode.id && disabledParent!==true"> <span ng-class="{mouseovercolor: isHighlighted, mouseleavecolor: !isHighlighted}" ng-mouseenter="isHighlighted=true" ng-mouseleave="isHighlighted=false"> {{communityNode.value}} <span ng-show="communityNode.isArchived">(inactive)</span> </span> </button> <button class="italic" style="opacity: 0.5;" ng-if="vm.disabledCommunityId===communityNode.id || disabledParent===true"> <span> {{communityNode.value}} <span ng-show="communityNode.isArchived">(inactive)</span> </span> </button> <div data-ng-disabled="vm.isLoading" ng-hide="communityNode.hideChildren"> <ul> <li ng-repeat="node in communityNode.children" ng-include="\'app/common/directives/communitiesDropDown/communityList.view.html\'" ng-init="communityNode = node;isHighlighted=false;disabledParent= vm.disabledCommunityId===communityNode.id || disabledParent===true" style="list-style: none;"></li> </ul> <div ng-init="vm.isLoading = false;"></div> </div> ');
$templateCache.put('app/common/directives/dropdown/dropdown.view.html','<span class="menu-dropdown-button" ng-class="{\'is-open\': vm.active}" ng-click="vm.toggle()"></span> <div ng-class="{\'is-open\': vm.active}"></div>');
$templateCache.put('app/common/directives/icon/icon.template.html','<svg class="icon icon-{{icon.name}}" ng-class="{\'icon-spin\': icon.spin}"> <use xlink:href="" data-ng-href="#icon-{{icon.name}}"></use> </svg>');
$templateCache.put('app/common/directives/learnAboutThisPage/learnAboutModal.template.html','<form name="form" ng-submit="$dismiss()"> <modal close="$dismiss" modal-title="{{vmWidgetModal.learnTitle}}"> <modal-body> <p ng-repeat="item in vmWidgetModal.textBodyParagraphs">{{item}}</p> </modal-body> <modal-footer> <div class="text-right"> <button type="submit" class="dflt button">OK</button> </div> </modal-footer> </modal> </form>');
$templateCache.put('app/common/directives/learnAboutThisPage/learnAboutThisPage.view.html','<div class="text-right" style="position:absolute; top: 0; right: 20px;"> <a ng-click="vmWidget.openModal()">Learn about this page</a> </div>');
$templateCache.put('app/common/directives/loadingIcon/loadingIcon.template.html','<div ng-if="loadingIcon.show" ng-class="{\'push-down\': loadingIcon.pushDown}"> <icon name="fa-spinner" class="icon-smallest" aria-hidden="true" ng-show="loadingIcon.littlest" spin="true"></icon> <icon name="fa-spinner" class="icon-big" aria-hidden="true" ng-show="loadingIcon.little" spin="true"></icon> <icon name="fa-spinner" class="icon-bigger" aria-hidden="true" ng-hide="loadingIcon.little||loadingIcon.littlest" spin="true"></icon> </div>');
$templateCache.put('app/common/directives/modal/modal.template.html','<div class="modal-header"> <h3>{{vm.modalTitle}}</h3> <button type="button" class="close-button" ng-click="vm.close()" ng-if="vm.close" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> <hr> </div> <div class="inner-form" ng-transclude="body"></div> <div class="row button-row" ng-transclude="footer"></div>');
$templateCache.put('app/components/logIn/passwordExpirationModal/passwordExpirationModal.view.html','<modal modal-title="Password Expiration Warning"> <modal-body> Your password will expire in {{vm.daysRemaining}} days. Please update your password. </modal-body> <modal-footer> <div class="pull-right"> <button type="button" class="dflt button" ng-click="$close()">OK</button> </div> </modal-footer> </modal>');}]);})();